<template>
    <div v-if="!loadingPage" class="pb-25">
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center mb-2">
                <b-button v-if="!automaticUpdates" class="btn-icon mr-50 mr-md-1 py-50 px-75 d-flex align-items-center"
                    @click="preInvoiceCreateModal" variant="info">
                    <feather-icon icon="PlusSquareIcon" size="23" />
                    <div class="ml-50">پیش‌سفارش</div>
                </b-button>
                <b-button v-if="tables.length" class="btn-icon d-flex align-items-center p-50" @click="showModalTable"
                    variant="info">
                    <feather-icon v-if="!loadingShowTable" size="23" icon="HexagonIcon" />
                    <b-spinner v-if="loadingShowTable" variant="white" class="p-50" small></b-spinner>
                </b-button>
            </div>
            <div class="d-flex justify-content-end align-items-center mb-2">
                <b-button v-if="!automaticUpdates" type="submit" variant="info" @click="ordersToday(true, true)"
                    :disabled="loadingButton" class="d-flex align-items-center py-75 px-75">
                    <div class="d-flex align-items-center">
                        <countdown v-if="startCounter" :time="timerCount">
                            <template slot-scope="props">
                                <div class="text-center mr-50" style="font-size: 16px;">
                                    {{ formatElapsed(props.totalMilliseconds) }}
                                </div>
                            </template>
                        </countdown>
                        <b-spinner v-if="loadingButton" variant="white" class="mr-75" small></b-spinner>
                        <div>
                            <feather-icon icon="RotateCwIcon" size="16" />
                        </div>
                    </div>
                </b-button>
                <b-button v-if="!automaticUpdates" class="btn-icon ml-50 ml-md-1 p-50" @click="changeViewMode"
                    variant="info">
                    <feather-icon v-if="viewModeList" icon="ListIcon" size="23" />
                    <feather-icon v-else icon="GridIcon" size="23" />
                </b-button>
                <div class="d-flex align-items-center ml-1 py-50 display-none-daily-orders">
                    <b-form-checkbox v-model="automaticUpdates" class="custom-control-info" name="check-button"
                        switch />
                    <div class="mb-0 ">
                        <feather-icon v-if="automaticUpdates" icon="BellIcon" size="25" />
                        <feather-icon v-else icon="BellOffIcon" size="25" />
                    </div>
                </div>
            </div>
        </div>
        <b-row v-if="!automaticUpdates" class="mb-1">
            <b-col xl="2" lg="6" md="6" class="mt-25">
                <b-form-group label="شماره سفارش" label-for="dailyOrderNumberId">
                    <b-form-input v-model="parameters.dailyOrderNumber" @keyup.enter="ordersToday(false, true)"
                        id="dailyOrderNumberId" dir="ltr" type="number" autocomplete="off" class="text-center"
                        name="dailyOrderNumberId" />
                </b-form-group>
            </b-col>
            <b-col xl="2" lg="6" md="6" class="mt-25">
                <b-form-group label="نام مشتری" label-for="customerNameId">
                    <b-form-input v-model="parameters.customerName" @keyup.enter="ordersToday(false, true)"
                        id="customerNameId" dir="rtl" autocomplete="off" class="text-center" name="customerNameId" />
                </b-form-group>
            </b-col>
            <b-col xl="2" lg="4" md="4" class="mt-25">
                <b-form-group label="وضعیت پرداخت" label-for="isPreOrderId">
                    <v-select v-model="parameters.isPreOrder" dir="rtl" :options="isPreOrderData" autocomplete="off"
                        :searchable="false" id="isPreOrderId" :reduce="(value) => value.id" class="bg-white"
                        style="border-radius: 6px;" label="name" :clearable="false">
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col xl="3" lg="4" md="4" class="mt-25">
                <b-form-group label="وضعیت آماده سازی" label-for="preparationStatusId">
                    <v-select v-model="parameters.preparationStatus" dir="rtl" :options="preparationStatusData"
                        autocomplete="off" :searchable="false" id="preparationStatusId" :reduce="(value) => value.id"
                        class="bg-white" style="border-radius: 6px;" label="name" :clearable="false">
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col xl="3" lg="4" md="4" class="mt-25">
                <b-form-group label="وضعیت سفارش" label-for="isReturnedId">
                    <v-select v-model="parameters.isReturned" dir="rtl" :options="isReturnedData" autocomplete="off"
                        :searchable="false" id="isReturnedId" :reduce="(value) => value.id" class="bg-white"
                        style="border-radius: 6px;" label="name" :clearable="false">
                    </v-select>
                </b-form-group>
            </b-col>
        </b-row>
        <div v-if="viewModeList">
            <b-card class="p-0" no-body>
                <b-overlay :show="loading2" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table v-if="orders.length" responsive :items="orders" :fields="fields" class="mb-0" striped>
                        <template #cell(preparationStatus)="data">
                            <b-badge
                                @click="changeStatus(data.item.id, data.item.preparationStatus, data.item.isPreOrder)"
                                class="pointer" :variant="preparationVariant(data.item.preparationStatus)" pill>
                                {{ preparationStatus(data.item.preparationStatus) }}
                            </b-badge>
                        </template>
                        <template #cell(storeOrderNumber)="data">
                            {{ data.item.storeOrderNumber ? data.item.storeOrderNumber : '-' }}
                        </template>
                        <template #cell(customer)="data">
                            {{ data.item.customer ? data.item.customer.lastName : '-' }}
                        </template>
                        <template #cell(createdAt)="data">
                            {{ data.item.createdAt ? new
                                Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0, 2).join(":") : '-'
                            }}
                        </template>
                        <template #cell(tableId)="data">
                            {{ data.item.tableId ? data.item.tableId : '-' }}
                        </template>
                        <template #cell(isPreOrder)="data">
                            <div>
                                {{ data.item.isPreOrder ? '❌' : '✔️' }}
                            </div>
                        </template>
                        <template #cell(type)="data">
                            {{ type_Status(data.item.type) }}
                        </template>
                        <template #cell(orderList)="data">
                            <feather-icon @click="showOrderList(data.item)" icon="ShoppingBagIcon"
                                class="text-info pointer" size="21" />
                        </template>
                    </b-table>
                    <div v-else class="text-center py-5">
                        موردی وجود ندارد
                    </div>
                </b-overlay>
            </b-card>
            <hr v-if="orders.length" class="mb-50 mt-0">
            <div v-if="orders.length" class="d-flex justify-content-center mb-2">
                <b-button @click="moreOrders" variant="flat-primary" :disabled="loadingButton"
                    class="d-flex align-items-center">
                    <h5 class="mb-0 text-primary">مشاهده بیشتر</h5>
                    <b-spinner v-if="loadingButton" variant="primary" class="ml-75" small></b-spinner>
                    <feather-icon v-else icon="ArrowDownIcon" class="text-primary ml-50" size="18" />
                </b-button>
            </div>
        </div>
        <div v-else>
            <b-row v-if="orders.length">
                <b-col v-for="(item, index) in orders" :key="`orders${index}`" xl="4" lg="6" md="6">
                    <b-card class="p-0" no-body>
                        <b-overlay :show="loading2" variant="transparent" opacity="1" blur="3px" rounded="sm">
                            <div class="p-2">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <div>سفارش</div>
                                        <h4 class="ml-50 mb-0">{{ item.dailyNumber }}</h4>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <b-badge @click="changeStatus(item.id, item.preparationStatus, item.isPreOrder)"
                                            class="pointer" :variant="preparationVariant(item.preparationStatus)" pill>
                                            {{ preparationStatus(item.preparationStatus) }}
                                        </b-badge>
                                        <feather-icon @click="routeChangeHandle(item, 'pre-invoice')" icon="EditIcon"
                                            class="pointer ml-1" size="21"
                                            :class="!item.isPreOrder || loadingButtonEdit ? 'text-muted' : 'text-info'" />
                                        <feather-icon @click="printCustomerInvoiceModal(item.id)" icon="PrinterIcon"
                                            class="text-info pointer ml-1" size="21" />
                                        <feather-icon @click="showOrderList(item)" icon="ShoppingBagIcon"
                                            class="text-info pointer ml-1" size="21" />
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between mt-1">
                                    <h5 class="mb-0">
                                        {{
                                            item.customer ? `${item.customer.firstName} ${item.customer.lastName}`
                                                : 'مشتری مجموعه'
                                        }}
                                    </h5>
                                    <div :class="item.isPreOrder ? 'text-danger' : 'text-success'">
                                        {{ item.isPreOrder ? 'پرداخت نشده' : 'پرداخت شده' }}
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between mt-1">
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0">
                                            {{ item.tableName ? item.tableName : 'جایگاه' }}
                                        </h5>
                                    </div>
                                    <div>
                                        {{ type_Status(item.type) }}
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between mt-1">
                                    <div class="d-flex align-items-center">
                                        <div>زمان ثبت</div>
                                        <h5 class="ml-50 mb-0">
                                            {{ new Date(item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                                2).join(":") }}
                                        </h5>
                                    </div>
                                    <div>
                                        {{ getTimeAgo(item.createdAt) }}
                                    </div>
                                </div>
                                <b-row class="mt-1">
                                    <b-col md="6" class="mb-1 mb-md-0">
                                        <b-button :disabled="loadingListExtra" @click="showOrderListExtra(item.id)"
                                            class="d-flex justify-content-center w-100 py-75" variant="outline-info">
                                            <span>جزئیات بیشتر</span>
                                            <b-spinner v-if="loadingListExtra" variant="info" class="ml-50"
                                                small></b-spinner>
                                        </b-button>
                                    </b-col>
                                    <b-col md="6">
                                        <b-button :disabled="!item.isPreOrder || loadingButtonComplete"
                                            @click="routeChangeHandle(item)" variant="success"
                                            class="w-100 py-75 d-flex align-items-center justify-content-center">
                                            <b-spinner v-if="loadingButtonComplete" variant="white" class="mr-50"
                                                small></b-spinner>
                                            <span>تکمیل</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-overlay>
                    </b-card>
                </b-col>
            </b-row>
            <b-card v-else class="p-0" no-body>
                <div class="text-center py-5">
                    موردی وجود ندارد
                </div>
            </b-card>
            <hr v-if="orders.length" class="mb-50 mt-0">
            <div v-if="orders.length" class="d-flex justify-content-center mb-2">
                <b-button @click="moreOrders" variant="flat-primary" :disabled="loadingButton"
                    class="d-flex align-items-center">
                    <h5 class="mb-0 text-primary">مشاهده بیشتر</h5>
                    <b-spinner v-if="loadingButton" variant="primary" class="ml-75" small></b-spinner>
                    <feather-icon v-else icon="ArrowDownIcon" class="text-primary ml-50" size="18" />
                </b-button>
            </div>
        </div>


        <!------------------------------- modal print invoice ------------------------------->
        <b-modal id="print-invoice" title="پرینت سفارش" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <h5 class="text-center pb-25">
                    آیا از پرینت این سفارش مطمئن هستید؟
                </h5>

                <b-button type="submit" variant="primary" @click="printCustomerInvoice" :disabled="loadingButton"
                    class="w-100 mt-2 d-flex align-items-center justify-content-center">
                    <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                    <span>تایید</span>
                </b-button>
            </div>
        </b-modal>

        <!------------------------------- modal update status ------------------------------->
        <b-modal id="update-status" title="تغییر وضعیت" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <div @click="selectedStatus = status.id" v-for="(status, index) in statuses" :key="index">
                    <div v-if="!(status.id == 3 && !isPreOrder)"
                        class="text-center p-75 rounded border border-secondary pointer mb-1"
                        :class="status.id == selectedStatus ? statusVariant(selectedStatus) : null">
                        {{ status.name }}
                    </div>
                </div>

                <b-button type="submit" variant="info" @click="updatePreparationStatus" :disabled="loadingButton2"
                    class="w-100 mt-2 d-flex align-items-center justify-content-center">
                    <b-spinner v-if="loadingButton2" class="mr-50" variant="white" small></b-spinner>
                    <span>تغییر وضعیت</span>
                </b-button>
            </div>
        </b-modal>

        <!------------------------------- modal show order list ------------------------------->
        <b-modal id="show-order-list" title="جزئیات سفارش" centered :hide-footer="true" title-class="font-weight-bolder"
            size="lg">
            <div class="p-75">
                <b-table responsive :items="orderList" :fields="fieldsOrderDetails" class="mb-0" striped
                    thead-class="d-none" borderless>
                    <template #cell(count)="data">
                        <div class="d-flex align-items-center justify-content-end">
                            <h5 class="font-weight-bolder mr-25 mb-0">{{ data.item.count }}</h5>
                            <span>عدد</span>
                        </div>
                    </template>
                    <template #cell(name)="data">
                        <div class="d-flex align-items-center py-25">
                            <div class="d-flex align-items-center">
                                <h5 class="text-center pr-25 mb-0">{{ data.index + 1 }}</h5>
                                <span>-</span>
                            </div>
                            <h5 class="mb-0 ml-50">
                                {{ data.item.name }}
                            </h5>
                        </div>
                    </template>
                </b-table>


                <div v-if="ordertableName" class="d-flex align-items-center justify-content-between mt-2">
                    <div>
                        <h5 class="text-secondary">جایگاه</h5>
                        <h5 class="mb-0">{{ ordertableName }}
                        </h5>
                    </div>
                    <b-media no-body>
                        <b-media-aside class="mr-0">
                            <b-avatar rounded size="48" variant="light-secondary">
                                <feather-icon size="20" icon="HexagonIcon" />
                            </b-avatar>
                        </b-media-aside>
                    </b-media>
                </div>


                <div v-if="orderDescription" class="d-flex align-items-center justify-content-between mt-2">
                    <div>
                        <h5 class="text-secondary">توضیحات سفارش</h5>
                        <h5 class="mb-0">{{ orderDescription }}
                        </h5>
                    </div>
                    <b-media no-body>
                        <b-media-aside class="mr-0">
                            <b-avatar rounded size="48" variant="light-secondary">
                                <feather-icon size="20" icon="FileTextIcon" />
                            </b-avatar>
                        </b-media-aside>
                    </b-media>
                </div>

                <div v-if="orderLastName || orderFirstName"
                    class="d-flex align-items-center justify-content-between mt-2">
                    <div>
                        <h5 class="text-secondary">نام مشتری</h5>
                        <h5 class="mb-0">{{ orderFirstName + " " + orderLastName }}
                        </h5>
                    </div>
                    <b-media no-body>
                        <b-media-aside class="mr-0">
                            <b-avatar rounded size="48" variant="light-secondary">
                                <feather-icon size="20" icon="UserIcon" />
                            </b-avatar>
                        </b-media-aside>
                    </b-media>
                </div>

                <b-row v-if="viewModeList">
                    <b-col md="6" lg="3">
                        <b-button :disabled="loadingListExtra" @click="showOrderListExtra"
                            class="d-flex justify-content-center w-100 mt-2" variant="info">
                            <span>جزئیات بیشتر</span>
                            <b-spinner v-if="loadingListExtra" variant="white" class="ml-50" small></b-spinner>
                        </b-button>
                    </b-col>
                    <b-col md="6" lg="3">
                        <b-button type="submit" variant="primary" @click="printCustomerInvoice"
                            :disabled="loadingButton"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>پرینت</span>
                        </b-button>
                    </b-col>
                    <b-col md="6" lg="3">
                        <b-button :disabled="!isPreOrder || loadingButtonEdit"
                            @click="routeChangeHandle('', 'pre-invoice')"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center" variant="primary">
                            <b-spinner v-if="loadingButtonEdit" class="mr-50" variant="white" small></b-spinner>
                            <span>ویرایش</span>
                        </b-button>
                    </b-col>
                    <b-col md="6" lg="3">
                        <b-button :disabled="!isPreOrder || loadingButtonComplete" @click="routeChangeHandle"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center" variant="success">
                            <b-spinner v-if="loadingButtonComplete" class="mr-50" variant="white" small></b-spinner>
                            <span>تکمیل</span>
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <!------------------------------- modal show order list extra ------------------------------->
        <b-modal id="show-order-list-extra" title="جزئیات سفارش" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <div>
                <invoiceDetail :orderDetails="orderDetailsExtra" />
            </div>
        </b-modal>
        <!------------------------------- modal pre invoice ------------------------------->
        <b-modal id="pre-invoice-modal" :title="modeOrder == 'Edit' ? 'ویرایش پیش‌سفارش' : 'ثبت پیش‌سفارش'" centered
            :hide-footer="true" title-class="font-weight-bolder" size="xl" body-class="p-0" content-class="">
            <b-card no-body class="px-2 py-50 mb-1 mb-md-2">
                <b-row class="align-items-center">
                    <b-col xl="6" lg="12" md="12">
                        <b-row>
                            <b-col md="6" class="py-50 py-md-1">
                                <div>
                                    <v-select v-model="orderForm.tableId" dir="rtl" :options="tables" autocomplete="off"
                                        id="tableId" :reduce="(value) => value.id" class="bg-white"
                                        placeholder="انتخاب جایگاه" style="border-radius: 6px;" label="name">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                </div>
                            </b-col>
                            <b-col md="6" class="py-50 py-md-1">
                                <div>
                                    <b-form-input v-model="orderForm.description" autocomplete="off" id="description"
                                        dir="rtl" class="text-center" placeholder="توضیحات سفارش" />
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col xl="6" lg="12" md="12">
                        <b-row>
                            <b-col md="6" cols="12"
                                class="d-flex align-items-center justify-content-center py-50 py-md-50">
                                <div
                                    class="d-flex align-items-center justify-content-center flex-wrap border border-secondary py-75 rounded w-100">
                                    <h5 class="mb-0 text-center px-50">
                                        {{ customer.phoneNumber ? `${customer.firstName}
                                        ${customer.lastName}` : 'مشتری مجموعه' }}
                                    </h5>
                                    <h5 v-if="customer.phoneNumber" class="mb-0 mt-25 px-50 text-center">
                                        {{ customer.phoneNumber ? customer.phoneNumber : '' }}
                                    </h5>
                                </div>
                            </b-col>
                            <b-col md="3" cols="6" class="py-50 py-md-1">
                                <div @click="showModalCustomersFind" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon :class="{ 'text-muted': loading.customersFind }" icon="UserIcon"
                                            size="26" />
                                    </div>
                                    <div style="font-size: 13px;" :class="{ 'text-muted': loading.customersFind }"
                                        class="font-weight-bolder text-center">مشتری
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="3" cols="6" class="py-50 py-md-1">
                                <div @click="deleteInvoice" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon icon="TrashIcon" size="26" />
                                    </div>
                                    <div style="font-size: 13px;" class="font-weight-bolder text-center">حذف
                                        اطلاعات
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
            <b-row class="match-height">
                <b-col xl="8" lg="12" md="12">
                    <b-row class="match-height h-100">
                        <b-col xl="3" lg="4" cols="4" class="pr-25 pr-md-1">
                            <div class="overflow-y-scroll-pre-invoice mb-2 mb-xl-0">
                                <b-card no-body @dblclick.prevent class="mb-0">
                                    <div v-for="(item, index) in categories" :key="`category${index}`"
                                        :class="{ 'bg-info-pre-invoice': category.id == item.id }"
                                        class="pointer border-bottom-pre-invoice p-1" @click="selectCategory(item)">
                                        <h5 class="mb-0" :class="{ 'text-white': category.id == item.id }">
                                            {{ item.name_Fa }}
                                        </h5>
                                    </div>
                                </b-card>
                            </div>
                        </b-col>
                        <b-col xl="9" lg="8" cols="8" class="pl-25 pl-md-1">
                            <b-card no-body class="overflow-y-scroll-pre-invoice mb-2 mb-xl-0">
                                <div class="h-100">
                                    <div v-if="category.products.length"
                                        class="d-flex flex-wrap justify-content-center py-50" @dblclick.prevent>
                                        <div v-for="(item, index) in category.products" :key="index"
                                            :class="item.isAvailable ? 'border border-primary' : 'border border-warning'"
                                            class="rounded pointer m-25 m-md-1 d-flex justify-content-center align-items-center position-relative pre-invoice-registration-bg"
                                            @click="addedToOrderList(item)">
                                            <div v-if="item.number"
                                                class="position-absolute text-white z-index-2 bg-secondary rounded-circle"
                                                style="left: 5px;top: 4px;width: 23px;height: 23px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    {{ item.number }}
                                                </div>
                                            </div>
                                            <div v-if="item.number" @click.stop="subtractProduct(item)"
                                                class="position-absolute text-white z-index-2 rounded-circle"
                                                style="left: 5px;bottom: 4px;width: 24px;height: 24px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <feather-icon icon="MinusCircleIcon" size="24"
                                                        class="text-danger" />
                                                </div>
                                            </div>
                                            <div v-if="item.discountPercent"
                                                class="position-absolute text-white z-index-2 bg-danger rounded-bottom"
                                                style="right: 6px;top: -1px;width: 33px;height: 24px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            {{ item.discountPercent }}
                                                        </div>
                                                        <div>%</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="position-absolute z-index-1 rounded pre-invoice-registration-cover-product"
                                                :class="{ 'pre-invoice-registration-cover-product-warning': !item.isAvailable }"
                                                :style="{ backgroundColor: !item.isAvailable ? '#724500b0' : item.color || '#000000ad' }">
                                            </div>
                                            <div v-if="item.image"
                                                class="position-absolute rounded pre-invoice-registration-bg-main"
                                                :class="item.isAvailable ? 'border border-primary' : 'border border-warning'">
                                                <img :src="BASE_URL_File + item.image"
                                                    class="object-fit-cover rounded w-100 h-100">
                                            </div>
                                            <div
                                                class="text-center position-relative z-index-1 text-truncate-4-line px-75">
                                                <div class="mb-0 text-white text-ellipsis-single-pre-invoice"
                                                    style="font-size: 16px;">
                                                    {{ item.name_Fa }}
                                                </div>
                                                <div class="d-flex align-items-center justify-content-center mb-0"
                                                    style="color: #dddddd;">
                                                    <div style="font-size: 16px;">
                                                        {{ item.basePrice.toLocaleString('fa-IR') }}
                                                    </div>
                                                    <div class="pb-25 pl-25">
                                                        ریال
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div @dblclick.prevent>
                                        <div v-for="(subCategories, index) in category.subCategories" class="mt-1"
                                            :key="`subCategories${index}`">
                                            <div class="mx-75 mb-25 mb-md-0 px-1 py-50 rounded border border-secondary text-center"
                                                style="font-size: 16px;">
                                                {{ subCategories.name_Fa }}
                                            </div>
                                            <div class="d-flex flex-wrap justify-content-center">
                                                <div v-for="(item, index) in subCategories.products"
                                                    :key="`products${index}`"
                                                    :class="item.isAvailable ? 'border border-primary' : 'border border-warning'"
                                                    class="rounded pointer m-25 m-md-1 d-flex justify-content-center align-items-center position-relative pre-invoice-registration-bg"
                                                    @click="addedToOrderList(item)">
                                                    <div v-if="item.number"
                                                        class="position-absolute text-white z-index-2 bg-secondary rounded-circle"
                                                        style="left: 5px;top: 4px;width: 23px;height: 23px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            {{ item.number }}
                                                        </div>
                                                    </div>
                                                    <div v-if="item.number" @click.stop="subtractProduct(item)"
                                                        class="position-absolute text-white z-index-2 rounded-circle"
                                                        style="left: 5px;bottom: 4px;width: 24px;height: 24px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            <feather-icon icon="MinusCircleIcon" size="24"
                                                                class="text-danger" />
                                                        </div>
                                                    </div>
                                                    <div v-if="item.discountPercent"
                                                        class="position-absolute text-white z-index-2 bg-danger rounded-bottom"
                                                        style="right: 6px;top: -1px;width: 33px;height: 24px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            <div class="d-flex align-items-center">
                                                                <div>
                                                                    {{ item.discountPercent }}
                                                                </div>
                                                                <div>%</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="position-absolute z-index-1 rounded pre-invoice-registration-cover-product"
                                                        :class="{ 'pre-invoice-registration-cover-product-warning': !item.isAvailable }"
                                                        :style="{ backgroundColor: !item.isAvailable ? '#724500b0' : item.color || '#000000ad' }">
                                                    </div>
                                                    <div v-if="item.image"
                                                        class="position-absolute rounded pre-invoice-registration-bg-main"
                                                        :class="item.isAvailable ? 'border border-primary' : 'border border-warning'">
                                                        <img :src="BASE_URL_File + item.image"
                                                            class="object-fit-cover rounded w-100 h-100">
                                                    </div>
                                                    <div
                                                        class="text-center position-relative z-index-1 text-truncate-4-line px-75">
                                                        <div class="mb-0 text-white text-ellipsis-single-pre-invoice"
                                                            style="font-size: 16px;">
                                                            {{ item.name_Fa }}
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-center mb-0"
                                                            style="color: #dddddd;">
                                                            <div style="font-size: 16px;">
                                                                {{ item.basePrice.toLocaleString('fa-IR') }}
                                                            </div>
                                                            <div class="pb-25 pl-25">
                                                                ریال
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col xl="4" lg="12" md="12">
                    <b-card class="mb-0">
                        <div>
                            <b-form-group label="نوع سفارش">
                                <v-select v-model="orderForm.type" :searchable="false" dir="rtl"
                                    :options="orderTypeItems" :reduce="(value) => value.id" label="name"
                                    id="orderTypeItemsId" class="bg-white" style="border-radius: 6px;"
                                    :clearable="false">
                                </v-select>
                            </b-form-group>
                        </div>
                        <hr class="border-secondary mb-25 mt-2">
                        <div class="px-1 orders-container-pre-invoice">
                            <div v-if="ordersList.length">
                                <div v-for="(item, index) in ordersList" :key="`order${index}`"
                                    class="py-75 d-flex align-items-center"
                                    :class="{ 'border-bottom': index != ordersList.length - 1 || index == 0 }">
                                    <div class="w-100">
                                        <div class="d-flex justify-content-between mb-75">
                                            <h5 class="mb-0">
                                                {{ item.name_Fa }}
                                            </h5>
                                            <div v-if="item.discountPercent" class="d-flex align-items-center">
                                                <h5 class="font-weight-bolder text-danger mb-0">
                                                    {{ item.discountPercent }}
                                                </h5>
                                                <div class="text-muted ml-25">%</div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex justify-content-between align-items-center"
                                                @dblclick.prevent style="width: 80px;">
                                                <feather-icon @click="addProduct(item)" icon="PlusCircleIcon"
                                                    class="pointer text-success" size="18" />
                                                <span class="font-weight-bolder">{{ item.number }}</span>
                                                <feather-icon @click="subtractProduct(item)" icon="MinusCircleIcon"
                                                    class="pointer text-danger" size="18" />
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <h5 v-if="item.discountPercent"
                                                    class="mr-75 mb-0 text-muted font-weight-bolder">
                                                    {{ item.basePrice.toLocaleString('fa-IR') }}
                                                </h5>
                                                <div class="d-flex align-items-center">
                                                    <h5 class="mb-0 font-weight-bolder">
                                                        {{ item.finalPrice.toLocaleString('fa-IR') }}
                                                    </h5>
                                                    <h6 class="pb-25 ml-25 mb-0 text-muted">ریال</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 v-else class="d-flex align-items-center justify-content-center h-100 mb-0 py-5">
                                محصولی به سفارش اضافه نشده است!
                            </h5>
                        </div>
                        <hr class="border-secondary mt-25">
                        <b-row class="mt-1">
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> تعداد </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">{{ orderDetails.numberProducts
                                        }}
                                        </h5>
                                        <span v-if="orderDetails.numberProducts" class="text-muted">عدد</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> جمع سفارش </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round(orderDetails.orderAmount).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="orderDetails.orderAmount" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> مالیات </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round((calculatingTaxAuto ? (orderDetails.orderAmount *
                                                0.10) : 0)).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="calculatingTaxAuto && orderDetails.orderAmount * 0.10 != 0"
                                            class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <div class="d-flex justify-content-center align-items-center mt-50">
                            <div class="d-flex align-items-center mb-2 mx-1">
                                <span> مبلغ قابل پرداخت : </span>
                                <h3 class="text-success mb-0 mx-25">
                                    {{ calculatingTaxAuto ? (orderDetails.amountPayable +
                                        (orderDetails.orderAmount * 0.10)).toLocaleString('fa-IR') :
                                        orderDetails.amountPayable.toLocaleString('fa-IR') }}
                                </h3>
                                <span v-if="calculatingTaxAuto ? (orderDetails.amountPayable +
                                    (orderDetails.orderAmount * 0.10)) :
                                    orderDetails.amountPayable" class="text-muted font-weight-bold">ریال</span>
                            </div>
                        </div>
                        <b-button type="submit" variant="primary" @click="preOrdetHandle"
                            :disabled="loading.preInvoiceCreate"
                            class="w-100 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.preInvoiceCreate" class="mr-50" variant="white" small></b-spinner>
                            <span>{{ modeOrder == 'Edit' ? 'ویرایش' : 'ثبت' }} پیش‌سفارش</span>
                        </b-button>
                    </b-card>
                </b-col>
            </b-row>
        </b-modal>


        <!------------------------------- modal customers find ------------------------------->
        <b-modal id="customers-find" title="افزودن مشتری" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <validation-observer ref="customersFindValidation">
                    <b-form @submit.prevent>
                        <b-form-group label="نام یا شماره اشتراک" label-for="searchCustomer" class="text-center">
                            <v-select dir="rtl" v-model="searchCustomer" :options="customerList" :filterable="false"
                                id="searchCustomer" @search="handleSearchCustomer" :loading="loadingCustomer"
                                :get-option-label="(option) => option.number + ' - ' + option.firstName + ' ' + option.lastName">
                                <template #option="{ number, firstName, lastName, phoneNumber }">
                                    <div class="d-flex align-items-center">
                                        <div>{{ number }}</div>
                                        <span class="mx-50">-</span>
                                        <div class="mr-50">{{ firstName }}</div>
                                        <div>{{ lastName }}</div>
                                        <span class="mx-50">/</span>
                                        <div>{{ phoneNumber }}</div>
                                    </div>
                                </template>
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                                <template #spinner="{ loading }">
                                    <div v-if="loadingCustomer" style="border-right-color: #7367f0" class="vs__spinner">
                                    </div>
                                </template>
                            </v-select>
                        </b-form-group>
                        <b-form-group label="شماره همراه" label-for="phone" class="text-center mt-3">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                                <cleave :disabled="!!searchCustomer" id="phone" dir="ltr" v-model="customerPhoneNumber"
                                    inputmode="numeric" autocomplete="off"
                                    class="form-control text-center font-weight-bolder"
                                    :class="{ 'border-danger': errors.length > 0 }" :options="options.phone" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-button type="submit" variant="info" @click="customersFind" :disabled="loading.customersFind"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.customersFind" class="mr-50" variant="white" small></b-spinner>
                            <span>افزودن</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <!------------------------------- modal create customer ------------------------------->
        <b-modal id="create-customer" title="ایجاد مشتری" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <validation-observer ref="createCustomerValidation">
                    <b-form @submit.prevent>

                        <!-- firstName -->
                        <b-form-group label="نام" label-for="firstNameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="firstNameId"
                                    v-model="customerForm.firstName" name="firstName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- lastName -->
                        <b-form-group label="نام خانوادگی" label-for="lastNameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="lastNameId"
                                    v-model="customerForm.lastName" name="lastName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- phone number -->
                        <b-form-group label="شماره همراه" label-for="phoneNumberId" class="text-center">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                                <b-form-input autocomplete="off" dir="ltr" id="phoneNumberId" inputmode="numeric"
                                    v-model="customerForm.phoneNumber" name="phoneNumber"
                                    :state="errors.length > 0 ? false : null"
                                    class="text-center font-weight-bolder user-select-none" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- birthDate -->
                        <div>
                            <b-form-group label="تاریخ تولد" label-for="birthDateId" class="text-center">
                                <b-form-input id="birthDateId" class="text-center main-input font-weight-bolder pointer"
                                    :value="customerForm.birthDate ? new Date(customerForm.birthDate).toLocaleDateString('fa-IR') : null"
                                    name="birthDateId" />
                            </b-form-group>
                            <date-picker v-model="customerForm.birthDate" :max="currentDate" format="YYYY-MM-DD"
                                display-format="jYYYY-jMM-jDD" custom-input="#birthDateId" />
                        </div>

                        <!-- gender -->
                        <div>
                            <div class="label mb-25 text-center">جنسیت</div>
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 100%;height: 2.714rem;">
                                <div class="d-flex align-items-center">
                                    <b-form-radio v-model="customerForm.gender" name="some-radios" :value="0"
                                        class="custom-control-primary mr-2">
                                        آقا
                                    </b-form-radio>
                                    <b-form-radio v-model="customerForm.gender" name="some-radios" :value="1"
                                        class="custom-control-primary ml-2">
                                        خانم
                                    </b-form-radio>
                                </div>
                            </div>
                        </div>

                        <b-button type="submit" variant="primary" @click="createCustomer"
                            :disabled="loading.createCustomer"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.createCustomer" class="mr-50" variant="white" small></b-spinner>
                            <span>ایجاد</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>
        <!------------------------------- modal complete order ------------------------------->
        <b-modal id="complete-order-modal" title="تکمیل سفارش" centered :hide-footer="true"
            title-class="font-weight-bolder" size="xl" body-class="p-0" content-class="">
            <b-card no-body class="py-50 px-2 mb-1">
                <b-row class="align-items-center">
                    <b-col lg="8" md="12">
                        <b-row>
                            <b-col lg="2" md="12" cols="6" class="display-none-sm-invoice-2 py-1">
                                <div class="d-flex align-items-center">
                                    <b-form-checkbox v-model="automaticPrinting" class="custom-control-info"
                                        name="check-button-complete" :disabled="!(certificateId || certificateId == 0)"
                                        switch />
                                    <div class="mb-0 ml-25">
                                        <feather-icon icon="PrinterIcon" size="26" />
                                    </div>
                                </div>
                            </b-col>
                            <b-col lg="5" md="6" class="py-50 py-md-1">
                                <div>
                                    <v-select v-model="orderFormComplete.tableId" dir="rtl" :options="tables"
                                        autocomplete="off" id="tableId" :reduce="(value) => value.id" class="bg-white"
                                        placeholder="انتخاب جایگاه" style="border-radius: 6px;" label="name">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                </div>
                            </b-col>
                            <b-col lg="5" md="6" class="py-50 py-md-1">
                                <div>
                                    <b-form-input v-model="orderFormComplete.description" autocomplete="off"
                                        id="descriptionComplete" dir="rtl" class="text-center"
                                        placeholder="توضیحات سفارش" />
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="4" md="12">
                        <b-row>
                            <b-col md="6" cols="6" class="py-1">
                                <div @click="showModalCustomersFindComplete" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon :class="{ 'text-muted': loading.customersFindComplete }"
                                            icon="UserIcon" size="26" />
                                    </div>
                                    <div style="font-size: 13px;"
                                        :class="{ 'text-muted': loading.customersFindComplete }"
                                        class="font-weight-bolder text-center">مشتری
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" cols="6" class="py-1">
                                <div @click="deleteInvoiceComplete" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon icon="TrashIcon" size="26" />
                                    </div>
                                    <div style="font-size: 13px;" class="font-weight-bolder text-center">حذف
                                        اطلاعات
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
            <b-card v-if="customerComplete.phoneNumber" no-body class="mb-1">
                <div class="d-flex flex-wrap flex-column flex-lg-row justify-content-center pt-1">
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">نام مشتری: </h6>
                            <h5 class="mb-0 ml-25">
                                {{ customerComplete.firstName || customerComplete.lastName ?
                                    `${customerComplete.firstName}
                                ${customerComplete.lastName}` : '' }}
                            </h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">شماره همراه: </h6>
                            <h5 class="mb-0 ml-25">{{ customerComplete.phoneNumber ? customerComplete.phoneNumber : ''
                            }}</h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">شماره اشتراک: </h6>
                            <h5 class="mb-0 ml-25">{{ customerComplete.number ? customerComplete.number : '' }}</h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">سطح: </h6>
                            <h5 class="mb-0 ml-25">{{ customerComplete.loyaltyInfo ?
                                `${customerComplete.loyaltyInfo.loyaltyLevel.name}
                                /
                                ${customerComplete.loyaltyInfo.loyaltyLevel.number}` : '' }}</h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">امتیاز: </h6>
                            <h5 class="mb-0 ml-25">
                                {{ customerComplete.loyaltyInfo ?
                                    customerComplete.loyaltyInfo.score.toLocaleString('fa-IR') :
                                    '' }}
                            </h5>
                        </div>
                    </div>
                    <div class="px-2 pb-1">
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">اعتبار: </h6>
                            <h5 class="mb-0 ml-25">
                                {{ customerComplete.loyaltyInfo ?
                                    customerComplete.loyaltyInfo.walletBalance.toLocaleString('fa-IR') :
                                    '' }}
                                <span v-if="customerComplete.loyaltyInfo" class="mb-0 text-muted">
                                    {{ customerComplete.loyaltyInfo.walletBalance ? 'ریال' : null }}
                                </span>
                            </h5>
                        </div>
                    </div>
                </div>
            </b-card>
            <b-row class="match-height">
                <b-col xl="8" lg="12" md="12">
                    <b-row class="match-height h-100">
                        <b-col xl="3" lg="4" cols="4" class="pr-25 pr-md-1">
                            <div class="overflow-y-scroll-pre-invoice mb-2 mb-xl-0">
                                <b-card no-body @dblclick.prevent class="mb-0">
                                    <div v-for="(item, index) in categories" :key="`categoryComplete${index}`"
                                        :class="{ 'bg-info-pre-invoice': categoryComplete.id == item.id }"
                                        class="pointer border-bottom-pre-invoice p-1"
                                        @click="selectCategoryComplete(item)">
                                        <h5 class="mb-0" :class="{ 'text-white': categoryComplete.id == item.id }">
                                            {{ item.name_Fa }}
                                        </h5>
                                    </div>
                                </b-card>
                            </div>
                        </b-col>
                        <b-col xl="9" lg="8" cols="8" class="pl-25 pl-md-1">
                            <b-card no-body class="overflow-y-scroll-pre-invoice mb-2 mb-xl-0">
                                <div class="h-100">
                                    <div v-if="categoryComplete.products.length"
                                        class="d-flex flex-wrap justify-content-center py-50" @dblclick.prevent>
                                        <div v-for="(item, index) in categoryComplete.products"
                                            :key="`productComplete${index}`"
                                            :class="item.isAvailable ? 'border border-primary' : 'border border-warning'"
                                            class="rounded pointer m-25 m-md-1 d-flex justify-content-center align-items-center position-relative pre-invoice-registration-bg"
                                            @click="addedToOrderListComplete(item)">
                                            <div v-if="item.number"
                                                class="position-absolute text-white z-index-2 bg-secondary rounded-circle"
                                                style="left: 5px;top: 4px;width: 23px;height: 23px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    {{ item.number }}
                                                </div>
                                            </div>
                                            <div v-if="item.number" @click.stop="subtractProductComplete(item)"
                                                class="position-absolute text-white z-index-2 rounded-circle"
                                                style="left: 5px;bottom: 4px;width: 24px;height: 24px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <feather-icon icon="MinusCircleIcon" size="24"
                                                        class="text-danger" />
                                                </div>
                                            </div>
                                            <div v-if="item.discountPercent"
                                                class="position-absolute text-white z-index-2 bg-danger rounded-bottom"
                                                style="right: 6px;top: -1px;width: 33px;height: 24px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <div class="d-flex align-items-center">
                                                        <div>{{ item.discountPercent }}</div>
                                                        <div>%</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="position-absolute z-index-1 rounded pre-invoice-registration-cover-product"
                                                :class="{ 'pre-invoice-registration-cover-product-warning': !item.isAvailable }"
                                                :style="{ backgroundColor: !item.isAvailable ? '#724500b0' : item.color || '#000000ad' }">
                                            </div>
                                            <div v-if="item.image"
                                                class="position-absolute rounded pre-invoice-registration-bg-main"
                                                :class="item.isAvailable ? 'border border-primary' : 'border border-warning'">
                                                <img :src="BASE_URL_File + item.image"
                                                    class="object-fit-cover rounded w-100 h-100">
                                            </div>
                                            <div
                                                class="text-center position-relative z-index-1 text-truncate-4-line px-75">
                                                <div class="mb-0 text-white text-ellipsis-single-pre-invoice"
                                                    style="font-size: 16px;">
                                                    {{ item.name_Fa }}
                                                </div>
                                                <div class="d-flex align-items-center justify-content-center mb-0"
                                                    style="color: #dddddd;">
                                                    <div style="font-size: 16px;">
                                                        {{ item.basePrice.toLocaleString('fa-IR') }}
                                                    </div>
                                                    <div class="pb-25 pl-25">ریال</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div @dblclick.prevent>
                                        <div v-for="(subCategories, index) in categoryComplete.subCategories"
                                            class="mt-1" :key="`subCategoriesComplete${index}`">
                                            <div class="mx-75 mb-25 mb-md-0 px-1 py-50 rounded border border-secondary text-center"
                                                style="font-size: 16px;">
                                                {{ subCategories.name_Fa }}
                                            </div>
                                            <div class="d-flex flex-wrap justify-content-center">
                                                <div v-for="(item, index) in subCategories.products"
                                                    :key="`productsSubComplete${index}`"
                                                    :class="item.isAvailable ? 'border border-primary' : 'border border-warning'"
                                                    class="rounded pointer m-25 m-md-1 d-flex justify-content-center align-items-center position-relative pre-invoice-registration-bg"
                                                    @click="addedToOrderListComplete(item)">
                                                    <div v-if="item.number"
                                                        class="position-absolute text-white z-index-2 bg-secondary rounded-circle"
                                                        style="left: 5px;top: 4px;width: 23px;height: 23px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            {{ item.number }}
                                                        </div>
                                                    </div>
                                                    <div v-if="item.number" @click.stop="subtractProductComplete(item)"
                                                        class="position-absolute text-white z-index-2 rounded-circle"
                                                        style="left: 5px;bottom: 4px;width: 24px;height: 24px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            <feather-icon icon="MinusCircleIcon" size="24"
                                                                class="text-danger" />
                                                        </div>
                                                    </div>
                                                    <div v-if="item.discountPercent"
                                                        class="position-absolute text-white z-index-2 bg-danger rounded-bottom"
                                                        style="right: 6px;top: -1px;width: 33px;height: 24px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            <div class="d-flex align-items-center">
                                                                <div>{{ item.discountPercent }}</div>
                                                                <div>%</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="position-absolute z-index-1 rounded pre-invoice-registration-cover-product"
                                                        :class="{ 'pre-invoice-registration-cover-product-warning': !item.isAvailable }"
                                                        :style="{ backgroundColor: !item.isAvailable ? '#724500b0' : item.color || '#000000ad' }">
                                                    </div>
                                                    <div v-if="item.image"
                                                        class="position-absolute rounded pre-invoice-registration-bg-main"
                                                        :class="item.isAvailable ? 'border border-primary' : 'border border-warning'">
                                                        <img :src="BASE_URL_File + item.image"
                                                            class="object-fit-cover rounded w-100 h-100">
                                                    </div>
                                                    <div
                                                        class="text-center position-relative z-index-1 text-truncate-4-line px-75">
                                                        <div class="mb-0 text-white text-ellipsis-single-pre-invoice"
                                                            style="font-size: 16px;">
                                                            {{ item.name_Fa }}
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-center mb-0"
                                                            style="color: #dddddd;">
                                                            <div style="font-size: 16px;">
                                                                {{ item.basePrice.toLocaleString('fa-IR') }}
                                                            </div>
                                                            <div class="pb-25 pl-25">ریال</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col xl="4" lg="12" md="12">
                    <b-card class="mb-0">
                        <b-row>
                            <b-col xl="6" lg="12" md="6">
                                <b-form-group label="نوع پرداخت">
                                    <v-select v-model="paymentMethodComplete" :searchable="false" dir="rtl"
                                        :options="paymentMethodItems" :reduce="(value) => value.id" label="name"
                                        id="paymentMethodCompleteId" class="bg-white" style="border-radius: 6px;"
                                        :clearable="false">
                                    </v-select>
                                </b-form-group>
                            </b-col>
                            <b-col xl="6" lg="12" md="6">
                                <b-form-group label="نوع سفارش">
                                    <v-select v-model="orderFormComplete.type" :searchable="false" dir="rtl"
                                        :options="orderTypeItems" :reduce="(value) => value.id" label="name"
                                        id="orderTypeItemsCompleteId" class="bg-white" style="border-radius: 6px;"
                                        :clearable="false">
                                    </v-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <hr class="border-secondary mb-25 mt-50">
                        <div class="px-1 orders-container-pre-invoice">
                            <div v-if="ordersListComplete.length">
                                <div v-for="(item, index) in ordersListComplete" :key="`orderComplete${index}`"
                                    class="py-75 d-flex align-items-center"
                                    :class="{ 'border-bottom': index != ordersListComplete.length - 1 || index == 0 }">
                                    <div class="w-100">
                                        <div class="d-flex justify-content-between mb-75">
                                            <h5 class="mb-0">{{ item.name_Fa }}</h5>
                                            <div v-if="item.discountPercent" class="d-flex align-items-center">
                                                <h5 class="font-weight-bolder text-danger mb-0">
                                                    {{ item.discountPercent }}
                                                </h5>
                                                <div class="text-muted ml-25">%</div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex justify-content-between align-items-center"
                                                @dblclick.prevent style="width: 80px;">
                                                <feather-icon @click="addProductComplete(item)" icon="PlusCircleIcon"
                                                    class="pointer text-success" size="18" />
                                                <span class="font-weight-bolder">{{ item.number }}</span>
                                                <feather-icon @click="subtractProductComplete(item)"
                                                    icon="MinusCircleIcon" class="pointer text-danger" size="18" />
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <h5 v-if="item.discountPercent"
                                                    class="mr-75 mb-0 text-muted font-weight-bolder">
                                                    {{ item.basePrice.toLocaleString('fa-IR') }}
                                                </h5>
                                                <div class="d-flex align-items-center">
                                                    <h5 class="mb-0 font-weight-bolder">
                                                        {{ item.finalPrice.toLocaleString('fa-IR') }}
                                                    </h5>
                                                    <h6 class="pb-25 ml-25 mb-0 text-muted">ریال</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 v-else class="d-flex align-items-center justify-content-center h-100 mb-0 py-5">
                                محصولی به سفارش اضافه نشده است!
                            </h5>
                        </div>
                        <hr class="border-secondary mt-25">
                        <div @click="showDivComplete = !showDivComplete" class="d-flex align-items-center">
                            <h5 class="mb-0 mr-50">تخفیف و اعتبار</h5>
                            <feather-icon v-if="!showDivComplete" icon="ChevronDownIcon" class="pointer" size="18" />
                            <feather-icon v-else icon="ChevronUpIcon" class="pointer" size="18" />
                        </div>
                        <div v-if="showDivComplete" class="toggle-content-invoice mt-1">
                            <b-row>
                                <b-col xl="6" lg="12">
                                    <b-form @submit.prevent>
                                        <b-form-group label="تخفیف دستی ریالی">
                                            <b-input-group>
                                                <cleave id="discountAmountComplete" dir="ltr"
                                                    v-model="discountAmountComplete" inputmode="numeric"
                                                    autocomplete="off" placeholder="0" class="form-control text-center"
                                                    :options="options.number" />
                                                <b-input-group-append>
                                                    <b-button type="submit" @click="applyDiscountComplete('rial')"
                                                        variant="outline-info px-75"
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'">
                                                        تایید
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-form>
                                </b-col>
                                <b-col xl="6" lg="12">
                                    <b-form @submit.prevent>
                                        <b-form-group label="تخفیف دستی درصدی">
                                            <b-input-group>
                                                <cleave id="percentageDiscountAmountComplete" dir="ltr"
                                                    v-model="percentageDiscountAmountComplete" inputmode="numeric"
                                                    autocomplete="off" placeholder="0" class="form-control text-center"
                                                    :options="options.number" />
                                                <b-input-group-append>
                                                    <b-button type="submit" @click="applyDiscountComplete('percentage')"
                                                        variant="outline-info px-75"
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'">
                                                        تایید
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-form>
                                </b-col>
                            </b-row>
                            <b-row class="mt-50">
                                <b-col xl="6" lg="12">
                                    <b-form @submit.prevent>
                                        <b-form-group label="هزینه ارسال (ریال)">
                                            <b-input-group>
                                                <cleave id="courierFeeAmountComplete" dir="ltr"
                                                    v-model="courierFeeAmountComplete" inputmode="numeric"
                                                    :disabled="orderFormComplete.type == 0" autocomplete="off"
                                                    placeholder="0" class="form-control text-center"
                                                    :options="options.number" />
                                                <b-input-group-append>
                                                    <b-button type="submit" @click="applyCourierFeeComplete"
                                                        :disabled="orderFormComplete.type == 0"
                                                        variant="outline-info px-75"
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'">
                                                        تایید
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-form>
                                </b-col>
                                <b-col xl="6" lg="12">
                                    <b-form @submit.prevent>
                                        <b-form-group label="استفاده از اعتبار (ریال)">
                                            <b-input-group>
                                                <cleave id="orderFormWalletAmountComplete" dir="ltr"
                                                    v-model="orderFormWalletAmountComplete" inputmode="numeric"
                                                    :disabled="!customerComplete.loyaltyInfo" autocomplete="off"
                                                    placeholder="0" class="form-control text-center"
                                                    :options="options.number" />
                                                <b-input-group-append>
                                                    <b-button type="submit" @click="orderUseWalletOkComplete"
                                                        :disabled="!customerComplete.loyaltyInfo"
                                                        variant="outline-info px-75"
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'">
                                                        تایید
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-form>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group label="کمپین">
                                        <v-select v-model="campaignDetailsComplete" :searchable="false" dir="rtl"
                                            :disabled="!campaignsListComplete.length" :options="campaignsListComplete"
                                            label="title" id="campaignDetailsCompleteId" class="bg-white"
                                            style="border-radius: 6px;">
                                            <template #no-options>
                                                موردی وجود ندارد
                                            </template>
                                        </v-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                        <hr class="border-secondary mt-1">
                        <b-row class="mt-1">
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> تعداد </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">{{ orderDetailsComplete.numberProducts
                                        }}
                                        </h5>
                                        <span v-if="orderDetailsComplete.numberProducts" class="text-muted">عدد</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> جمع سفارش </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round(orderDetailsComplete.orderAmount).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="orderDetailsComplete.orderAmount" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> مالیات </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round((calculatingTaxAuto ? (orderDetailsComplete.orderAmount *
                                                0.10) : 0)).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="calculatingTaxAuto && orderDetailsComplete.orderAmount * 0.10 != 0"
                                            class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> جمع کل </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round((calculatingTaxAuto ? (orderDetailsComplete.totalAmount +
                                                (orderDetailsComplete.orderAmount * 0.10)) :
                                                orderDetailsComplete.totalAmount)).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="calculatingTaxAuto ? (orderDetailsComplete.totalAmount +
                                            (orderDetailsComplete.orderAmount * 0.10)) :
                                            orderDetailsComplete.totalAmount" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col v-if="!!campaignDetailsComplete" md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> تخفیف کمپین </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round((calculatingTaxAuto ? (orderDetailsComplete.totalAmount +
                                                (orderDetailsComplete.orderAmount * 0.10)) :
                                                orderDetailsComplete.totalAmount) * (campaignDetailsComplete.discountPercent
                                                    /
                                                    100)).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="((calculatingTaxAuto ? (orderDetailsComplete.totalAmount +
                                            (orderDetailsComplete.orderAmount * 0.10)) :
                                            orderDetailsComplete.totalAmount) * (campaignDetailsComplete.discountPercent /
                                                100))" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> تخفیف دستی </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round(orderFormComplete.discountAmount).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="orderFormComplete.discountAmount != 0"
                                            class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col v-if="orderFormComplete.courierFee" md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> هزینه ارسال </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ orderFormComplete.courierFee.toLocaleString('fa-IR') }}
                                        </h5>
                                        <span class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> اعتبار </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ orderFormComplete.walletAmount ?
                                                orderFormComplete.walletAmount.toLocaleString('fa-IR') :
                                                '0' }}
                                        </h5>
                                        <span v-if="orderFormComplete.walletAmount" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <div class="d-flex justify-content-center align-items-center mt-50">
                            <div class="d-flex align-items-center mb-2 mx-1">
                                <span> مبلغ قابل پرداخت : </span>
                                <h3 class="text-success mb-0 mx-25">
                                    {{
                                        Math.max(
                                            Math.round(
                                                (calculatingTaxAuto ? orderDetailsComplete.totalAmount +
                                                    (orderDetailsComplete.orderAmount *
                                                        0.10) : orderDetailsComplete.totalAmount)
                                                - (campaignDetailsComplete ? ((calculatingTaxAuto ?
                                                    (orderDetailsComplete.totalAmount +
                                                        (orderDetailsComplete.orderAmount * 0.10)) : orderDetailsComplete.totalAmount) *
                                                    (campaignDetailsComplete.discountPercent / 100)) : 0)
                                                - orderFormComplete.discountAmount
                                                + (orderFormComplete.courierFee || 0)
                                                - (orderFormComplete.useWallet ? orderFormComplete.walletAmount : 0)
                                            ),
                                            0
                                        ).toLocaleString('fa-IR')
                                    }}
                                </h3>
                                <span v-if="calculatingTaxAuto ? (orderDetailsComplete.amountPayable +
                                    (orderDetailsComplete.orderAmount * 0.10)) :
                                    orderDetailsComplete.amountPayable" class="text-muted font-weight-bold">ریال</span>
                            </div>
                        </div>
                        <b-button type="submit" variant="primary" @click="ordersCreateCompleteHandle"
                            :disabled="loading.ordersCreateComplete"
                            class="w-100 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.ordersCreateComplete" class="mr-50" variant="white"
                                small></b-spinner>
                            <span>تکمیل سفارش</span>
                        </b-button>
                    </b-card>
                </b-col>
            </b-row>
        </b-modal>

        <!------------------------------- modal enter amount complete ------------------------------->
        <b-modal id="enter-amount-complete" title="پرداخت ترکیبی" centered :hide-footer="true"
            title-class="font-weight-bolder" size="sm">
            <div class="p-1">
                <b-form @submit.prevent>
                    <div class="d-flex align-items-center justify-content-center">
                        <div>مبلغ قابل پرداخت :</div>
                        <div class="d-flex align-items-center ml-50">
                            <h3 class="text-success mb-0">
                                {{
                                    Math.max(
                                        Math.round(
                                            (calculatingTaxAuto ? orderDetailsComplete.totalAmount +
                                                (orderDetailsComplete.orderAmount *
                                                    0.10) : orderDetailsComplete.totalAmount)
                                            - (campaignDetailsComplete ? ((calculatingTaxAuto ? (orderDetailsComplete.totalAmount +
                                                (orderDetailsComplete.orderAmount * 0.10)) : orderDetailsComplete.totalAmount) *
                                                (campaignDetailsComplete.discountPercent / 100)) : 0)
                                            - orderFormComplete.discountAmount
                                            + (orderFormComplete.courierFee || 0)
                                            - (orderFormComplete.useWallet ? orderFormComplete.walletAmount : 0)
                                        ),
                                        0
                                    ).toLocaleString('fa-IR')
                                }}
                            </h3>
                            <span v-if="calculatingTaxAuto ? (orderDetailsComplete.amountPayable +
                                (orderDetailsComplete.orderAmount * 0.10)) :
                                orderDetailsComplete.amountPayable"
                                class="text-muted font-weight-bold ml-25">ریال</span>
                        </div>
                    </div>
                    <div v-for="(item, index) in combinedPaymentComplete" :key="`paymentComplete_${index}`"
                        class="mt-2">
                        <b-form-group :label="item.name" label-for="phoneComplete" class="text-center">
                            <cleave id="numberComplete" dir="ltr" v-model="item.amount" autocomplete="off"
                                placeholder="0" inputmode="numeric" class="form-control font-weight-bolder text-center"
                                :options="options.number" />
                        </b-form-group>
                    </div>
                    <b-button type="submit" variant="primary" @click="combinedPaymentCompleteHandle"
                        :disabled="loading.ordersCreateComplete"
                        class="w-100 mt-2 d-flex align-items-center justify-content-center">
                        <b-spinner v-if="loading.ordersCreateComplete" class="mr-50" variant="white" small></b-spinner>
                        <span>تکمیل سفارش</span>
                    </b-button>
                </b-form>
            </div>
        </b-modal>

        <!------------------------------- modal customers find complete ------------------------------->
        <b-modal id="customers-find-complete" title="افزودن مشتری" centered :hide-footer="true"
            title-class="font-weight-bolder" size="sm">
            <div class="p-1">
                <validation-observer ref="customersFindCompleteValidation">
                    <b-form @submit.prevent>
                        <b-form-group label="نام یا شماره اشتراک" label-for="searchCustomerComplete"
                            class="text-center">
                            <v-select dir="rtl" v-model="searchCustomerComplete" :options="customerListComplete"
                                :filterable="false" id="searchCustomerComplete" @search="handleSearchCustomerComplete"
                                :loading="loadingCustomerComplete"
                                :get-option-label="(option) => option.number + ' - ' + option.firstName + ' ' + option.lastName">
                                <template #option="{ number, firstName, lastName, phoneNumber }">
                                    <div class="d-flex align-items-center">
                                        <div>{{ number }}</div>
                                        <span class="mx-50">-</span>
                                        <div class="mr-50">{{ firstName }}</div>
                                        <div>{{ lastName }}</div>
                                        <span class="mx-50">/</span>
                                        <div>{{ phoneNumber }}</div>
                                    </div>
                                </template>
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                                <template #spinner="{ loading }">
                                    <div v-if="loadingCustomerComplete" style="border-right-color: #7367f0"
                                        class="vs__spinner">
                                    </div>
                                </template>
                            </v-select>
                        </b-form-group>
                        <b-form-group label="شماره همراه" label-for="phoneComplete" class="text-center mt-3">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                                <cleave :disabled="!!searchCustomerComplete" id="phoneComplete" dir="ltr"
                                    v-model="customerPhoneNumberComplete" inputmode="numeric" autocomplete="off"
                                    class="form-control text-center font-weight-bolder"
                                    :class="{ 'border-danger': errors.length > 0 }" :options="options.phone" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-button type="submit" variant="info" @click="customersFindComplete"
                            :disabled="loading.customersFindComplete"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.customersFindComplete" class="mr-50" variant="white"
                                small></b-spinner>
                            <span>افزودن</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <!------------------------------- modal create customer complete ------------------------------->
        <b-modal id="create-customer-complete" title="ایجاد مشتری" centered :hide-footer="true"
            title-class="font-weight-bolder" size="sm">
            <div class="p-1">
                <validation-observer ref="createCustomerCompleteValidation">
                    <b-form @submit.prevent>

                        <!-- firstName -->
                        <b-form-group label="نام" label-for="firstNameCompleteId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="firstNameCompleteId"
                                    v-model="customerFormComplete.firstName" name="firstNameComplete"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- lastName -->
                        <b-form-group label="نام خانوادگی" label-for="lastNameCompleteId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="lastNameCompleteId"
                                    v-model="customerFormComplete.lastName" name="lastNameComplete"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- phone number -->
                        <b-form-group label="شماره همراه" label-for="phoneNumberCompleteId" class="text-center">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                                <b-form-input autocomplete="off" dir="ltr" id="phoneNumberCompleteId"
                                    inputmode="numeric" v-model="customerFormComplete.phoneNumber"
                                    name="phoneNumberComplete" :state="errors.length > 0 ? false : null"
                                    class="text-center font-weight-bolder user-select-none" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- birthDate -->
                        <div>
                            <b-form-group label="تاریخ تولد" label-for="birthDateCompleteId" class="text-center">
                                <b-form-input id="birthDateCompleteId"
                                    class="text-center main-input font-weight-bolder pointer"
                                    :value="customerFormComplete.birthDate ? new Date(customerFormComplete.birthDate).toLocaleDateString('fa-IR') : null"
                                    name="birthDateCompleteId" />
                            </b-form-group>
                            <date-picker v-model="customerFormComplete.birthDate" :max="currentDate" format="YYYY-MM-DD"
                                display-format="jYYYY-jMM-jDD" custom-input="#birthDateCompleteId" />
                        </div>

                        <!-- gender -->
                        <div>
                            <div class="label mb-25 text-center">جنسیت</div>
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 100%;height: 2.714rem;">
                                <div class="d-flex align-items-center">
                                    <b-form-radio v-model="customerFormComplete.gender" name="some-radios-complete"
                                        :value="0" class="custom-control-primary mr-2">
                                        آقا
                                    </b-form-radio>
                                    <b-form-radio v-model="customerFormComplete.gender" name="some-radios-complete"
                                        :value="1" class="custom-control-primary ml-2">
                                        خانم
                                    </b-form-radio>
                                </div>
                            </div>
                        </div>

                        <b-button type="submit" variant="primary" @click="createCustomerComplete"
                            :disabled="loading.createCustomerComplete"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.createCustomerComplete" class="mr-50" variant="white"
                                small></b-spinner>
                            <span>ایجاد</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <!------------------------------- modal show table------------------------------->
        <b-modal id="show-table" title="جایگاه‌ها" centered :hide-footer="true" title-class="font-weight-bolder"
            size="md" body-class="p-0">
            <div>
                <b-table responsive :items="tables" :fields="fieldsTables" class="mb-0" striped>
                    <template #cell(isInUse)="data">
                        <span v-if="data.item.isInUse" class="text-danger">در حال استفاده</span>
                        <span v-else class="text-success">آماده استفاده</span>
                    </template>
                </b-table>
            </div>
        </b-modal>

        <div v-if="certificateId || certificateId == 0">
            <Printer ref="PrinterComplete" :customerInvoice="orderPrintComplete" :provider="provider"
                @deleteInvoice="deleteInvoiceComplete" />
        </div>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BBadge, BFormRadio, BSpinner, BFormCheckbox, BAvatar, BForm, BMediaAside, BMedia, BFormInput, BFormGroup, BOverlay, BInputGroup, BInputGroupAppend } from 'bootstrap-vue';
import { storeService } from '@core/services';
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.ir'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, phoneNumber } from '@validations';
import invoiceDetail from '@/@core/components/invoice-detail/index.vue';
import Printer from '@/@core/components/printer/index.vue';
import * as signalR from '@microsoft/signalr'
import { accessHandling } from '@core/mixins/accessHandling';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BSpinner,
        BBadge,
        BFormCheckbox,
        BAvatar,
        BMediaAside,
        BFormInput,
        BFormGroup,
        BMedia,
        BOverlay,
        BForm,
        BFormRadio,
        BInputGroup,
        BInputGroupAppend,
        vSelect,
        invoiceDetail,
        Printer
    },
    directives: {
        Ripple,
    },
    mixins: [accessHandling],
    data() {
        return {
            required,
            phoneNumber,
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
                phone: {
                    phone: true,
                    phoneRegionCode: 'IR',
                    delimiter: '-',
                }
            },
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            currentDate: '',
            loading: {
                preInvoiceCreate: false,
                customersFind: false,
                createCustomer: false,
                customersFindComplete: false,
                createCustomerComplete: false,
                ordersCreateComplete: false,
            },
            tables: [],
            categories: [],
            category: {
                products: []
            },
            categoryComplete: {
                products: [],
                subCategories: []
            },
            orderTypeItems: [
                { name: 'داخل سالن', id: 0 },
                { name: 'بیرون بر', id: 1 },
            ],
            paymentMethodItems: [
                { name: 'کارت', id: 1 },
                { name: 'نقدی', id: 0 },
                { name: 'واریز به حساب', id: 3 },
                { name: 'ترکیبی', id: 4 },
            ],
            combinedPaymentComplete: [
                { name: 'نقدی', method: 0, amount: null },
                { name: 'کارت', method: 1, amount: null },
                { name: 'واریز به حساب', method: 3, amount: null },
            ],
            ordersList: [],
            ordersListComplete: [],
            orderDetails: {
                numberProducts: 0,
                totalAmount: 0,
                orderAmount: 0,
                amountPayable: 0
            },
            orderDetailsComplete: {
                numberProducts: 0,
                totalAmount: 0,
                orderAmount: 0,
                amountPayable: 0
            },
            orderForm: {
                customerNumber: null,
                items: [],
                tableId: null,
                description: null,
                type: 0,
            },
            orderFormComplete: {
                courierFee: null,
                discountAmount: 0,
                payments: [],
                type: 0,
                orderId: null,
                items: [],
                tableId: null,
                description: null,
                customerNumber: null,
                useWallet: false,
                walletAmount: 0,
                campaignId: null
            },
            fieldsTables: [
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'isInUse',
                    label: 'وضعیت',
                },
                {
                    key: 'capacity',
                    label: 'ظرفیت',
                },
            ],
            courierFeeAmountComplete: null,
            calculatingTaxAuto: false,
            searchCustomer: null,
            searchCustomerComplete: null,
            loadingCustomer: false,
            loadingCustomerComplete: false,
            customerList: [],
            customerListComplete: [],
            parametersCustomer: {
                pageIndex: 1,
                pageSize: 4,
                searchTerm: null,
            },
            parametersCustomerComplete: {
                pageIndex: 1,
                pageSize: 4,
                searchTerm: null,
            },
            customerPhoneNumber: null,
            customerPhoneNumberComplete: null,
            customer: {
                phoneNumber: null,
                lastName: null,
                number: null,
                firstName: null,
            },
            customerComplete: {
                phoneNumber: null,
                lastName: null,
                number: null,
                firstName: null,
                loyaltyInfo: null,
            },
            customerForm: {
                gender: null,
                birthDate: null,
                lastName: null,
                firstName: null,
                phoneNumber: null
            },
            customerFormComplete: {
                gender: null,
                birthDate: null,
                lastName: null,
                firstName: null,
                phoneNumber: null
            },
            modeOrder: null,
            notification: null,
            loadingPage: true,
            loading2: false,
            loadingButton: false,
            loadingButtonEdit: false,
            loadingButtonComplete: false,
            loadingButton2: false,
            storeId: null,
            timerCount: 86400000,
            startCounter: false,
            orders: [],
            storeOrderNumber: null,
            isReturnedData: [
                { id: null, name: 'نمایش همه' },
                { id: true, name: 'مرجوع شده یا لغو شده' },
                { id: false, name: 'مرجوع نشده یا لغو نشده' },
            ],
            isPreOrderData: [
                { id: null, name: 'نمایش همه' },
                { id: false, name: 'پرداخت شده' },
                { id: true, name: 'پرداخت نشده' },
            ],
            preparationStatusData: [
                { name: 'همه', id: null },
                { name: 'در انتظار تایید', id: 0 },
                { name: 'در حال آماده سازی', id: 1 },
                { name: 'تکمیل شده', id: 2 }
            ],
            fieldsOrderDetails: [
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'count',
                    label: 'نعداد',
                },
            ],
            fields: [
                {
                    key: 'dailyNumber',
                    label: 'شماره سفارش',
                },
                {
                    key: 'storeOrderNumber',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'createdAt',
                    label: 'زمان ثبت',
                },
                {
                    key: 'tableName',
                    label: 'جایگاه',
                },
                {
                    key: 'customer',
                    label: 'نام مشتری',
                },
                {
                    key: 'type',
                    label: 'نوع سفارش',
                },
                {
                    key: 'orderList',
                    label: 'جزئیات',
                },
                {
                    key: 'isPreOrder',
                    label: 'پرداخت',
                },
                {
                    key: 'preparationStatus',
                    label: 'وضعیت آماده سازی',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                hasNextPage: null,
                dailyOrderNumber: null,
                preparationStatus: null,
                isPreOrder: null,
                tableId: null,
                customerName: null,
                isReturned: null
            },
            orderId: null,
            dailyNumber: null,
            selectedStatus: null,
            statuses: [
                { name: 'لغو شده', id: 3 },
                { name: 'در انتظار تایید', id: 0 },
                { name: 'در حال آماده سازی', id: 1 },
                { name: 'تکمیل شده', id: 2 }
            ],
            orderList: [],
            connection: null,
            counter: 0,
            orderDescription: null,
            ordertableName: null,
            orderLastName: null,
            orderFirstName: null,
            orderAddress: null,
            orderType: null,
            registeredBy: null,
            selfStop: false,
            isReconnecting: false,
            isConnecting: false,
            reconnectIntervalId: null,
            automaticUpdates: false,
            isPreOrder: null,
            orderDetailsExtra: {},
            loadingListExtra: false,
            viewModeList: true,
            paymentMethodComplete: 1,
            showDivComplete: false,
            discountAmountComplete: null,
            percentageDiscountAmountComplete: null,
            orderFormWalletAmountComplete: 0,
            campaignsListComplete: [],
            campaignsListMainComplete: [],
            campaignDetailsComplete: null,
            isCustomerCampaignComplete: false,
            dataResponseComplete: {},
            orderPrintComplete: {
                items: []
            },
            printQueueComplete: [],
            isPrintingComplete: false,
            orderNumberComplete: 1,
            certificateId: null,
            automaticPrinting: true,
            provider: {},
            urlName: '',
            debounceTimeoutComplete: null,
            debounceTimeout: null,
            loadingShowTable: false,
        }
    },
    computed: {
        type_Status() {
            return (status) => {
                if (status == 0) {
                    return 'داخل سالن'
                }
                if (status == 1) {
                    return 'بیرون بر'
                }
            }
        },
        preparationStatus() {
            return (status) => {
                if (status == 0) {
                    return 'در انتظار تایید'
                }
                if (status == 1) {
                    return 'در حال آماده سازی'
                }
                if (status == 2) {
                    return 'تکمیل شده'
                }
                if (status == 3) {
                    return 'لغو شده'
                }
            }
        },
        preparationVariant() {
            return (status) => {
                if (status == 0) {
                    return 'light-warning'
                }
                if (status == 1) {
                    return 'light-primary'
                }
                if (status == 2) {
                    return 'light-success'
                }
                if (status == 3) {
                    return 'light-danger'
                }
            }
        },
        statusVariant() {
            return (status) => {
                if (status == 0) {
                    return 'bg-warning text-white border-warning'
                }
                if (status == 1) {
                    return 'bg-primary text-white border-primary'
                }
                if (status == 2) {
                    return 'bg-success text-white border-success'
                }
                if (status == 3) {
                    return 'bg-danger text-white border-danger'
                }
            }
        },
    },
    watch: {
        'campaignDetailsComplete'(newVal, oldVal) {
            if (this.orderFormComplete.discountAmount > 0) {
                let taxAmount = this.calculatingTaxAuto ? (this.orderDetailsComplete.orderAmount * 0.10) : 0
                let totalAmount = this.orderDetailsComplete.totalAmount + taxAmount
                let oldCampaignDiscount = oldVal
                    ? Math.round(totalAmount * (oldVal.discountPercent / 100))
                    : 0
                let newCampaignDiscount = newVal
                    ? Math.round(totalAmount * (newVal.discountPercent / 100))
                    : 0
                let campaignDifference = newCampaignDiscount - oldCampaignDiscount
                if (campaignDifference > 0) {
                    this.orderFormComplete.discountAmount = Math.max(
                        this.orderFormComplete.discountAmount - campaignDifference,
                        0
                    )
                } else if (campaignDifference < 0) {
                    let maxDiscountable = totalAmount - newCampaignDiscount
                    this.orderFormComplete.discountAmount = Math.min(
                        this.orderFormComplete.discountAmount + Math.abs(campaignDifference),
                        maxDiscountable
                    )
                }
                this.recalculateAmountPayableComplete()
            }
        },
        'orderFormComplete.type'(newVal) {
            if (newVal === 0) {
                this.courierFeeAmountComplete = null
                this.orderFormComplete.courierFee = null
                this.recalculateAmountPayableComplete()
            }
        },
        'searchCustomer'() {
            if (this.searchCustomer) {
                this.customerPhoneNumber = this.searchCustomer.phoneNumber
            }
        },
        'searchCustomerComplete'() {
            if (this.searchCustomerComplete) {
                this.customerPhoneNumberComplete = this.searchCustomerComplete.phoneNumber
            }
        },
        async automaticUpdates(value) {
            this.loading2 = true
            if (value) {
                this.viewModeList = true
                localStorage.setItem("viewModeList", this.viewModeList)
                this.selfStop = false;
                this.connection = await this.startConnection();
            }
            else {
                this.selfStop = true;
                if (this.reconnectIntervalId) {
                    clearInterval(this.reconnectIntervalId);
                }
                if (this.connection) {
                    this.connection.stop();
                }
            }
            this.removeFilters()
        },
        'parameters.isReturned'() {
            if (!this.automaticUpdates) {
                this.ordersToday(false, true)
            }
        },
        'parameters.preparationStatus'() {
            if (!this.automaticUpdates) {
                this.ordersToday(false, true)
            }
        },
        'parameters.isPreOrder'() {
            if (!this.automaticUpdates) {
                this.ordersToday(false, true)
            }
        },
        'orderDetailsComplete.numberProducts'() {
            let discountAmount = this.orderFormComplete.discountAmount;
            let totalAmount = this.calculatingTaxAuto ? (this.orderDetailsComplete.totalAmount + (this.orderDetailsComplete.orderAmount * 0.10)) : this.orderDetailsComplete.totalAmount
            if (discountAmount > totalAmount) {
                this.orderDetailsComplete.amountPayable = this.orderDetailsComplete.amountPayable + this.orderFormComplete.discountAmount
                this.orderFormComplete.discountAmount = 0
            }
        },
        automaticPrinting(value) {
            localStorage.setItem("automaticPrinting", value)
        },
    },
    methods: {
        showModalTable() {
            this.loadingShowTable = true
            this.tablesActive('show-table')
        },
        preInvoiceCreateModal() {
            if (this.accessHandling('employee', 'preorder_create')) {
                this.deleteInvoice()
                this.modeOrder = 'Create'
                this.$bvModal.show('pre-invoice-modal')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        createCustomer() {
            this.$refs.createCustomerValidation.validate().then((success) => {
                if (success) {
                    this.loading.createCustomer = true;
                    storeService.createCustomer(this.storeId, this.customerForm).then(({ data }) => {
                        this.customer = data
                        this.customerForm.gender = null
                        this.customerForm.birthDate = null
                        this.customerForm.lastName = null
                        this.customerForm.firstName = null
                        this.customerForm.phoneNumber = null
                        this.loading.createCustomer = false;
                        this.$refs.createCustomerValidation.reset();
                        this.$bvModal.hide('create-customer')
                        this.$notif({ type: 'success', title: 'مشتری با موفقیت به پیش‌سفارش اضافه شد' });
                    })
                        .catch(() => {
                            this.$bvModal.hide('create-customer')
                            this.customerForm.gender = null
                            this.customerForm.birthDate = null
                            this.customerForm.lastName = null
                            this.customerForm.firstName = null
                            this.customerForm.phoneNumber = null
                            this.loading.createCustomer = false;
                        });
                }
            });
        },
        customersFind() {
            this.$refs.customersFindValidation.validate().then((success) => {
                if (success) {
                    if (this.searchCustomer) {
                        this.loading.customersFind = true;
                        this.customer = {
                            firstName: this.searchCustomer.firstName,
                            id: this.searchCustomer.id,
                            lastName: this.searchCustomer.lastName,
                            phoneNumber: this.searchCustomer.phoneNumber,
                            number: this.searchCustomer.number,
                        }
                        this.$bvModal.hide('customers-find')
                        this.$notif({ type: 'success', title: 'مشتری با موفقیت به پیش‌سفارش اضافه شد' });
                        this.loading.customersFind = false;
                        this.searchCustomer = null
                        this.customerPhoneNumber = null
                        this.$refs.customersFindValidation.reset();
                    }
                    else {
                        this.customerForm.gender = null
                        this.customerForm.birthDate = null
                        this.customerForm.lastName = null
                        this.customerForm.firstName = null
                        this.customerForm.phoneNumber = null
                        this.loading.customersFind = true;
                        storeService.customersFind(this.storeId, this.customerPhoneNumber).then(({ data }) => {
                            if (data.isExists) {
                                this.customer = data.customer
                                this.customerPhoneNumber = null
                                this.loading.customersFind = false
                                this.$bvModal.hide('customers-find')
                                this.$notif({ type: 'success', title: 'مشتری با موفقیت به پیش‌سفارش اضافه شد' });
                            }
                            else {
                                this.customerForm.phoneNumber = this.customerPhoneNumber
                                this.$bvModal.hide('customers-find')
                                this.$bvModal.show('create-customer')
                                this.customerPhoneNumber = null
                                this.$notif({ type: 'normal', title: 'مشتری با این شماره یافت نشد' });
                                this.loading.customersFind = false
                            }
                            this.$refs.customersFindValidation.reset();
                        })
                            .catch(() => {
                                this.$refs.customersFindValidation.reset();
                                this.loading.customersFind = false
                            });
                    }
                }
            });
        },
        showModalCustomersFind() {
            if (this.accessHandling('employee', 'customer_create')) {
                this.$bvModal.show('customers-find')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        handleSearchCustomer(searchTerm) {
            this.loadingCustomer = true
            clearTimeout(this.debounceTimeout)
            if (!searchTerm) {
                this.customerList = []
                this.loadingCustomer = false
                return
            }
            this.debounceTimeout = setTimeout(() => {
                this.getCustomers(searchTerm)
            }, 1000)
        },
        getCustomers(searchTerm) {
            this.parametersCustomer.searchTerm = searchTerm
            storeService.getCustomers(this.storeId, this.parametersCustomer).then(({ data }) => {
                this.customerList = data.items
                this.loadingCustomer = false
            })
        },
        keyboardHandling(event) {
            if (event.keyCode === 121 || event.keyCode === 120) {
                event.preventDefault();
                const modals = document.querySelectorAll('.modal.show');
                if (modals.length > 0) {
                    const lastModal = modals[modals.length - 1];
                    const modalId = lastModal.id;
                    if (modalId === 'pre-invoice-modal') {
                        if (!this.loading.preInvoiceCreate) {
                            if (this.modeOrder == 'Edit') {
                                this.preInvoiceEdit()
                            }
                            else {
                                this.preInvoiceCreate()
                            }
                        }
                    }
                    else if (modalId === 'complete-order-modal') {
                        if (!this.loading.ordersCreateComplete) {
                            this.ordersCreateCompleteHandle()
                        }
                    }
                }
            }
        },
        deleteInvoice() {
            this.customer.number = null
            this.customer.lastName = null
            this.customer.firstName = null
            this.customer.phoneNumber = null
            this.customerForm.gender = null
            this.customerForm.birthDate = null
            this.customerForm.lastName = null
            this.customerForm.firstName = null
            this.customerForm.phoneNumber = null
            this.orderForm.items = []
            this.orderForm.tableId = null
            this.orderForm.description = null
            this.orderForm.customerNumber = null
            this.orderDetails.numberProducts = 0
            this.orderDetails.totalAmount = 0
            this.orderDetails.orderAmount = 0
            this.orderDetails.amountPayable = 0
            this.orderForm.type = 0
            this.searchCustomer = null
            this.customerPhoneNumber = null
            this.ordersList = []
            if (this.categories.length) {
                this.categories.forEach(obj => {
                    obj.products.forEach(product => {
                        product.number = 0;
                    });
                    if (obj.subCategories.length) {
                        obj.subCategories.forEach(subCategorie => {
                            subCategorie.products.forEach(productSub => {
                                productSub.number = 0;
                            });
                        });
                    }
                });
            }
        },
        addedToOrderList(product) {
            if (product.isAvailable) {
                let productExists = this.ordersList.some(orderProduct => orderProduct.id === product.id);
                if (!productExists) {
                    this.ordersList.push(product);
                    product.number = 1
                    this.orderDetails.numberProducts += 1
                    this.orderDetails.orderAmount += product.finalPrice
                    this.orderDetails.totalAmount += product.finalPrice
                    this.orderDetails.amountPayable += product.finalPrice
                }
                else {
                    product.number += 1
                    this.orderDetails.numberProducts += 1
                    this.orderDetails.orderAmount += product.finalPrice
                    this.orderDetails.totalAmount += product.finalPrice
                    this.orderDetails.amountPayable += product.finalPrice
                }
            }
            else {
                this.$notif({ type: 'warning', title: `"${product.name_Fa}" ناموجود است` });
            }

        },
        addProduct(product) {
            product.number += 1
            this.orderDetails.numberProducts += 1
            this.orderDetails.orderAmount += product.finalPrice
            this.orderDetails.totalAmount += product.finalPrice
            this.orderDetails.amountPayable += product.finalPrice
        },
        subtractProduct(product) {
            product.number -= 1
            this.orderDetails.numberProducts -= 1
            this.orderDetails.totalAmount -= product.finalPrice
            this.orderDetails.orderAmount -= product.finalPrice
            this.orderDetails.amountPayable -= product.finalPrice
            if (product.number == 0) {
                this.ordersList = this.ordersList.filter((item) => item.id !== product.id);
            }
        },
        selectCategory(category) {
            this.category = category
        },
        preOrdetHandle() {
            if (this.modeOrder == 'Edit') {
                this.preInvoiceEdit()
            }
            else {
                this.preInvoiceCreate()
            }
        },
        preInvoiceEdit() {
            if (this.ordersList.length) {
                this.loading.preInvoiceCreate = true;
                this.orderForm.items = []
                this.ordersList.forEach(product => {
                    this.orderForm.items.push({
                        productId: product.id,
                        count: product.number
                    });
                });
                if (!this.orderForm.description) {
                    this.orderForm.description = null
                }
                if (!this.orderForm.tableId) {
                    this.orderForm.tableId = null
                }
                this.orderForm.customerNumber = this.customer.number
                storeService.ordersPreorderEdit(this.storeId, this.orderId, this.orderForm).then(({ data }) => {
                    this.loading.preInvoiceCreate = false;
                    this.deleteInvoice()
                    this.$bvModal.hide('pre-invoice-modal')
                    this.ordersToday(false, true);
                })
                    .catch(() => {
                        this.loading.preInvoiceCreate = false;
                    });
            }
            else {
                this.$notif({ type: 'normal', title: 'برای ویرایش پیش‌سفارش حداقل یک مورد اضافه کنید' });
            }
        },
        preInvoiceCreate() {
            if (this.ordersList.length) {
                this.loading.preInvoiceCreate = true;
                this.orderForm.items = []
                this.ordersList.forEach(product => {
                    this.orderForm.items.push({
                        productId: product.id,
                        count: product.number
                    });
                });
                if (!this.orderForm.description) {
                    this.orderForm.description = null
                }
                if (!this.orderForm.tableId) {
                    this.orderForm.tableId = null
                }
                this.orderForm.customerNumber = this.customer.number
                storeService.preInvoiceCreate(this.storeId, this.orderForm).then(({ data }) => {
                    this.loading.preInvoiceCreate = false;
                    this.$bvModal.hide('pre-invoice-modal')
                    this.ordersToday(false, true);
                    this.deleteInvoice()
                    this.$notif({ type: 'success', title: 'پیش‌سفارش با موفقیت ثبت شد' });
                })
                    .catch(() => {
                        this.loading.preInvoiceCreate = false;
                    });
            }
            else {
                this.$notif({ type: 'normal', title: 'برای ثبت پیش‌سفارش حداقل یک مورد اضافه کنید' });
            }
        },
        ordersPreorderFind(dailyNumber) {
            this.loadingButtonEdit = true;
            this.deleteInvoice()
            storeService.ordersPreorderFind(this.storeId, dailyNumber).then(({ data }) => {
                let ordersList = data.items;
                ordersList.forEach(product => {
                    this.orderDetails.numberProducts += product.count;
                    this.orderDetails.orderAmount += (product.finalPrice * product.count);
                    this.orderDetails.totalAmount += (product.finalPrice * product.count);
                    this.orderDetails.amountPayable += (product.finalPrice * product.count);
                    let originalProduct = null;
                    for (let category of this.categories) {
                        originalProduct = category.products.find(p => p.id === product.productId);
                        if (originalProduct) break;

                        if (category.subCategories && category.subCategories.length) {
                            for (let subCategory of category.subCategories) {
                                originalProduct = subCategory.products.find(p => p.id === product.productId);
                                if (originalProduct) break;
                            }
                            if (originalProduct) break;
                        }
                    }
                    if (originalProduct) {
                        originalProduct.number = product.count;
                        this.ordersList.push(originalProduct);
                    }
                });
                this.orderForm.type = data.type;
                if (data.tableId) {
                    this.orderForm.tableId = data.tableId;
                }
                if (data.description) {
                    this.orderForm.description = data.description;
                }
                if (data.customer) {
                    this.customer = {
                        firstName: data.customer.firstName,
                        id: data.customer.id,
                        lastName: data.customer.lastName,
                        phoneNumber: data.customer.phoneNumber,
                        number: data.customer.number,
                    };
                }
                this.$bvModal.hide('show-order-list')
                this.$bvModal.show('pre-invoice-modal')
                this.loadingButtonEdit = false;
            })
                .catch(() => {
                    this.loadingButtonEdit = false;
                });
        },
        removeFilters() {
            this.parameters.pageIndex = 1
            this.parameters.pageSize = 12
            this.parameters.hasNextPage = null
            this.parameters.dailyOrderNumber = null
            this.parameters.preparationStatus = null
            this.parameters.isPreOrder = null
            this.parameters.tableId = null
            this.parameters.customerName = null
            this.parameters.isReturned = null
            this.ordersToday(false, true)
        },
        getTimeAgo(dateString) {
            const serverDate = new Date(dateString);
            const now = new Date();
            const diffMs = now - serverDate;
            const diffMinutes = Math.floor(diffMs / (1000 * 60));
            const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

            if (diffMinutes < 60) {
                return `${diffMinutes} دقیقه پیش`;
            } else {
                const hours = diffHours;
                const minutes = diffMinutes % 60;

                if (minutes === 0) {
                    return `${hours} ساعت پیش`;
                } else {
                    return `${hours} ساعت و ${minutes} دقیقه پیش`;
                }
            }
        },
        changeViewMode() {
            this.viewModeList = !this.viewModeList
            localStorage.setItem("viewModeList", this.viewModeList)
        },
        showOrderListExtra(id) {
            if (this.accessHandling('employee', 'order_details_view')) {
                this.loadingListExtra = true
                let orderId = this.orderId
                if (!this.viewModeList) {
                    orderId = id
                }
                storeService.orderDetails(this.storeId, orderId).then(({ data }) => {
                    this.orderDetailsExtra = data
                    this.loadingListExtra = false
                    this.$bvModal.hide('show-order-list')
                    this.$bvModal.show('show-order-list-extra')
                })
                    .catch((err) => {
                        this.loadingListExtra = false
                    });
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        routeChangeHandle(item, mode) {
            if (item.isPreOrder || this.viewModeList) {
                if (mode == 'pre-invoice') {
                    if (this.accessHandling('employee', 'preorder_edit')) {
                        this.modeOrder = 'Edit'
                        if (!this.viewModeList) {
                            if (!this.loadingButtonEdit) {
                                this.orderId = item.id
                                this.ordersPreorderFind(item.dailyNumber)
                            }
                        }
                        else {
                            this.ordersPreorderFind(this.dailyNumber)
                        }
                    }
                    else {
                        this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
                    }
                }
                else {
                    if (this.accessHandling('employee', 'order_create')) {
                        if (!this.viewModeList) {
                            this.orderId = item.id
                            this.ordersPreorderFindComplete(item.dailyNumber)
                        } else {
                            this.ordersPreorderFindComplete(this.dailyNumber)
                        }
                    }
                    else {
                        this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
                    }
                }
            }
        },
        printCustomerInvoiceModal(id) {
            this.orderId = id
            this.$bvModal.show('print-invoice')
        },
        printCustomerInvoice() {
            this.loadingButton = true
            if (this.accessHandling('employee', 'manual_order_print')) {
                storeService.sendPrintOrderMessage(this.storeId, this.orderId).then(({ data }) => {
                    this.$notif({ type: 'success', title: 'درخواست با موفقیت ارسال شد' });
                    this.loadingButton = false
                    if (this.viewModeList) {
                        this.$bvModal.hide('show-order-list')
                    }
                    else {
                        this.$bvModal.hide('print-invoice')
                    }
                })
                    .catch(() => {
                        this.loadingButton = false
                    });
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        moreOrders() {
            if (this.parameters.hasNextPage) {
                if (this.counter >= this.parameters.pageSize) {
                    let pageIndex = this.counter / this.parameters.pageSize
                    this.parameters.pageIndex += Math.floor(pageIndex)
                }
                this.parameters.pageIndex++
                this.loadingButton = true
                storeService.ordersToday(this.storeId, this.parameters).then(({ data }) => {
                    this.parameters.hasNextPage = data.hasNextPage
                    if (data.items.length) {
                        data.items.forEach(obj => {
                            if (!this.orders.some(order => order.id === obj.id)) {
                                this.orders.push(obj)
                            }
                        });
                    }
                    this.loadingButton = false
                    this.counter = 0
                })
            }
            else {
                this.$notif({ type: 'normal', title: 'موردی وجود ندارد' });
            }
        },
        showOrderList(order) {
            this.orderList = order.items
            this.orderDescription = order.customerDescription
            this.ordertableName = order.tableName
            this.registeredBy = order.registeredBy
            this.orderFirstName = null
            this.orderLastName = null
            if (order.customer) {
                this.orderFirstName = order.customer.firstName
                this.orderLastName = order.customer.lastName
            }
            this.orderAddress = order.address
            this.orderType = order.type
            this.orderId = order.id
            this.dailyNumber = order.dailyNumber
            this.storeOrderNumber = order.storeOrderNumber
            this.isPreOrder = order.isPreOrder
            this.$bvModal.show('show-order-list')
        },
        changeStatus(id, status, isPreOrder) {
            if (this.accessHandling('employee', 'preparation_status_change')) {
                this.selectedStatus = status
                this.orderId = id
                this.isPreOrder = isPreOrder
                this.$bvModal.show('update-status')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        updatePreparationStatus() {
            this.loadingButton2 = true
            storeService.updatePreparationStatus(this.storeId, this.orderId, { status: this.selectedStatus }).then(({ data }) => {
                if (!this.automaticUpdates) {
                    this.ordersToday(false, false)
                }
                else {
                    this.$bvModal.hide('update-status')
                    this.loadingButton2 = false
                }
            })
                .catch(() => {
                    this.loadingButton2 = false
                });
        },
        formatElapsed(remainingMs) {
            const elapsed = this.timerCount - remainingMs;
            const totalSeconds = Math.floor(elapsed / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            const pad = (num) => String(num).padStart(2, '0');
            return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        },
        ordersToday(showNotif, loading) {
            if (loading) {
                this.loading2 = true
                this.startCounter = false
                this.loadingButton = true
            }
            this.parameters.pageIndex = 1
            this.parameters.pageSize = 12
            if (showNotif) {
                this.parameters.hasNextPage = null
                this.parameters.dailyOrderNumber = null
                this.parameters.preparationStatus = null
                this.parameters.isPreOrder = null
                this.parameters.tableId = null
                this.parameters.customerName = null
                this.parameters.isReturned = null
            }
            this.counter = 0
            storeService.ordersToday(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingButton2) {
                    this.$bvModal.hide('update-status')
                    this.loadingButton2 = false
                }
                if (this.loadingPage || !loading) {
                    this.parameters.hasNextPage = data.hasNextPage
                    this.orders = data.items
                    this.loadingButton = false
                    if (!this.automaticUpdates) {
                        this.startCounter = true
                    }
                    if (showNotif) {
                        this.$notif({ type: 'success', title: 'بروز رسانی با موفقیت انجام شد' });
                    }
                    this.loading2 = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.hasNextPage = data.hasNextPage
                        this.orders = data.items
                        this.loadingButton = false
                        if (!this.automaticUpdates) {
                            this.startCounter = true
                        }
                        if (showNotif) {
                            this.$notif({ type: 'success', title: 'بروز رسانی با موفقیت انجام شد' });
                        }
                        this.loading2 = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        async startConnection() {
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(`${process.env.VUE_APP_BASE_URL_Socket}hubs/orders`, {
                    accessTokenFactory: () => localStorage.getItem("accessToken"),
                    withCredentials: false,
                    transport: signalR.HttpTransportType.WebSockets,
                })
                .configureLogging(signalR.LogLevel.Critical)
                .build();
            this.connection.on("OrderCreated", (order) => {
                this.orders.unshift(order)
                if (this.orders.length > 12) {
                    this.orders.pop()
                }
                this.counter++
                this.playNotification2()
                this.$notif({ type: 'success', title: 'یک سفارش جدید ثبت شده است' });
            });
            this.connection.on("OrderUpdated", (order) => {
                if (this.orders.length) {
                    this.orders.forEach(obj => {
                        if (obj.id == order.id) {
                            obj.createdAt = order.createdAt
                            obj.customerDescription = order.customerDescription
                            obj.customer = order.customer
                            obj.address = order.address
                            obj.dailyNumber = order.dailyNumber
                            obj.tableId = order.tableId
                            obj.isPreOrder = order.isPreOrder
                            obj.items = order.items
                            obj.preparationStatus = order.preparationStatus
                            obj.registeredBy = order.registeredBy
                            obj.storeOrderNumber = order.storeOrderNumber
                            obj.type = order.type
                        }
                    });
                }
            });
            this.connection.on("OrderPreparationStatusUpdated", (orderId, status) => {
                if (this.orders.length) {
                    this.orders.forEach(obj => {
                        if (obj.id == orderId) {
                            obj.preparationStatus = status
                        }
                    });
                }
            });
            await this.tryConnect();
            this.connection.onclose(() => {
                if (!this.selfStop) {
                    this.startReconnectionCycle();
                }
            });
            return this.connection;
        },
        async tryConnect() {
            if (this.selfStop) return;
            if (this.isConnecting) return;
            this.isConnecting = true;
            try {
                await this.connection.start();
                await this.connection.send('ConnectToDailyOrdering')
            } catch (err) {
                setTimeout(() => {
                    this.isConnecting = false;
                    this.tryConnect();
                }, 5000);
                return;
            }
            this.isConnecting = false;
        },
        startReconnectionCycle() {
            if (this.isReconnecting) return;
            this.isReconnecting = true;
            this.reconnectIntervalId = setInterval(async () => {
                if (this.selfStop) {
                    clearInterval(this.reconnectIntervalId);
                    this.isReconnecting = false;
                    return;
                }
                if (!this.connection) {
                    await this.startConnection();
                    clearInterval(this.reconnectIntervalId);
                    this.isReconnecting = false;
                    return;
                }
                if (this.connection.state !== signalR.HubConnectionState.Connected) {
                    try {
                        if (!this.isConnecting) {
                            await this.connection.start();
                            await this.connection.send('ConnectToDailyOrdering')
                            clearInterval(this.reconnectIntervalId);
                            this.isReconnecting = false;
                        }
                    } catch (err) { }
                } else {
                    clearInterval(this.reconnectIntervalId);
                    this.isReconnecting = false;
                }
            }, 5000);
        },
        playNotification2() {
            this.notification.pause();
            this.notification.currentTime = 0;
            this.notification.play();
        },
        getInfo() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                this.calculatingTaxAuto = data.calculatingTaxAuto
                data.name_Fa ? this.provider.name = data.name_Fa : this.provider.name = data.name_En;
                this.urlName = data.name_En
                this.provider.logo = data.logoImage;
                this.ordersToday(false, false);
            })
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.tablesActive();
                }
                else {
                    this.loadingPage = true;
                }
            })
        },
        getAllProducts() {
            storeService.getAllProducts(this.storeId).then(({ data }) => {
                this.categories = data.categories
                if (this.categories.length) {
                    this.categories.forEach(obj => {
                        obj.products.forEach(product => {
                            product.number = 0;
                        });
                        if (obj.subCategories.length) {
                            obj.subCategories.forEach(subCategorie => {
                                subCategorie.products.forEach(productSub => {
                                    productSub.number = 0;
                                });
                            });
                        }
                    });
                }
                if (this.accessHandling('subscription', 3)) {
                    this.getCampaignsActivesComplete()
                }
                else {
                    this.getInfo()
                }
            })
        },
        getCampaignsActivesComplete() {
            storeService.getCampaignsActives(this.storeId).then(({ data }) => {
                this.campaignsListMainComplete = data.items
                this.campaignsListMainComplete.forEach(item => {
                    if (item.type == 2) {
                        this.campaignsListComplete.push(item)
                    }
                    if (item.type == 0 || item.type == 1) {
                        this.isCustomerCampaignComplete = true
                    }
                });
                if (this.campaignsListComplete.length) {
                    this.campaignDetailsComplete = this.campaignsListComplete[0]
                }
                this.getInfo()
            })
        },
        deleteInvoiceComplete() {
            this.customerFormComplete.gender = null
            this.customerFormComplete.birthDate = null
            this.customerFormComplete.lastName = null
            this.customerFormComplete.firstName = null
            this.customerFormComplete.phoneNumber = null
            this.customerComplete.number = null
            this.customerComplete.lastName = null
            this.customerComplete.firstName = null
            this.customerComplete.phoneNumber = null
            this.customerComplete.loyaltyInfo = null
            this.orderPrintComplete.address = null
            this.orderPrintComplete.phoneNumber = null
            this.orderPrintComplete.firstName = null
            this.orderPrintComplete.lastName = null
            this.orderFormComplete.discountAmount = 0
            this.orderFormComplete.courierFee = null
            this.courierFeeAmountComplete = null
            this.paymentMethodComplete = 1
            this.orderFormComplete.payments = []
            this.orderFormComplete.type = 0
            this.orderFormComplete.orderId = null
            this.orderFormComplete.items = []
            this.orderFormComplete.tableId = null
            this.orderFormComplete.description = null
            this.orderFormComplete.useWallet = false
            this.orderFormComplete.walletAmount = 0
            this.orderFormComplete.customerNumber = null
            this.orderFormComplete.campaignId = null
            this.campaignDetailsComplete = null
            this.orderDetailsComplete.numberProducts = 0
            this.orderDetailsComplete.totalAmount = 0
            this.orderDetailsComplete.orderAmount = 0
            this.orderDetailsComplete.amountPayable = 0
            this.searchCustomerComplete = null
            this.discountAmountComplete = null
            this.percentageDiscountAmountComplete = null
            this.orderFormWalletAmountComplete = 0
            this.ordersListComplete = []
            this.customerPhoneNumberComplete = null
            this.campaignsListComplete = []
            this.isCustomerCampaignComplete = false
            this.campaignsListMainComplete.forEach(item => {
                if (item.type == 2) {
                    this.campaignsListComplete.push(item)
                }
                if (item.type == 0 || item.type == 1) {
                    this.isCustomerCampaignComplete = true
                }
            });
            if (this.campaignsListComplete.length) {
                this.campaignDetailsComplete = this.campaignsListComplete[0]
            }
            if (this.categories.length) {
                this.categories.forEach(obj => {
                    obj.products.forEach(product => {
                        product.number = 0;
                    });
                    if (obj.subCategories.length) {
                        obj.subCategories.forEach(subCategorie => {
                            subCategorie.products.forEach(productSub => {
                                productSub.number = 0;
                            });
                        });
                    }
                });
            }
            this.combinedPaymentComplete.forEach(item => {
                item.amount = null;
            });
        },
        selectCategoryComplete(category) {
            this.categoryComplete = category
        },
        addedToOrderListComplete(product) {
            if (product.isAvailable) {
                let productExists = this.ordersListComplete.some(orderProduct => orderProduct.id === product.id);
                if (!productExists) {
                    this.ordersListComplete.push(product);
                    product.number = 1
                    this.orderDetailsComplete.numberProducts += 1
                    this.orderDetailsComplete.orderAmount += product.finalPrice
                    this.orderDetailsComplete.totalAmount += product.finalPrice
                    this.recalculateAmountPayableComplete()
                }
                else {
                    product.number += 1
                    this.orderDetailsComplete.numberProducts += 1
                    this.orderDetailsComplete.orderAmount += product.finalPrice
                    this.orderDetailsComplete.totalAmount += product.finalPrice
                    this.recalculateAmountPayableComplete()
                }
            }
            else {
                this.$notif({ type: 'warning', title: `"${product.name_Fa}" ناموجود است` });
            }
        },
        addProductComplete(product) {
            product.number += 1
            this.orderDetailsComplete.numberProducts += 1
            this.orderDetailsComplete.orderAmount += product.finalPrice
            this.orderDetailsComplete.totalAmount += product.finalPrice
            this.recalculateAmountPayableComplete()
        },
        subtractProductComplete(product) {
            product.number -= 1
            this.orderDetailsComplete.numberProducts -= 1
            this.orderDetailsComplete.totalAmount -= product.finalPrice
            this.orderDetailsComplete.orderAmount -= product.finalPrice
            if (product.number == 0) {
                this.ordersListComplete = this.ordersListComplete.filter((item) => item.id !== product.id);
            }
            this.recalculateAmountPayableComplete()
        },
        applyDiscountComplete(type) {
            if (type == 'rial') {
                let discountAmountNumber = Number(this.discountAmountComplete);
                let discountAmount = Math.round(discountAmountNumber);
                let taxAmount = this.calculatingTaxAuto ? (this.orderDetailsComplete.orderAmount * 0.10) : 0
                let totalBeforeCourier = this.orderDetailsComplete.totalAmount + taxAmount
                let campaignDiscount = this.campaignDetailsComplete
                    ? Math.round((this.orderDetailsComplete.totalAmount + taxAmount) * (this.campaignDetailsComplete.discountPercent / 100))
                    : 0
                let maxDiscountable = totalBeforeCourier - campaignDiscount

                if (discountAmount > maxDiscountable) {
                    this.$notif({ type: 'normal', title: 'تخفیف نمی‌تواند بیشتر از مبلغ قابل تخفیف باشد' });
                } else {
                    this.orderFormComplete.discountAmount = discountAmount;
                    this.recalculateAmountPayableComplete()
                }
                this.percentageDiscountAmountComplete = null
                this.discountAmountComplete = null
            }
            if (type == 'percentage') {
                let percentageDiscountAmount = Number(this.percentageDiscountAmountComplete);
                let taxAmount = this.calculatingTaxAuto ? (this.orderDetailsComplete.orderAmount * 0.10) : 0
                let totalBeforeCourier = this.orderDetailsComplete.totalAmount + taxAmount
                let campaignDiscount = this.campaignDetailsComplete
                    ? Math.round((this.orderDetailsComplete.totalAmount + taxAmount) * (this.campaignDetailsComplete.discountPercent / 100))
                    : 0
                let maxDiscountable = totalBeforeCourier - campaignDiscount

                let discountAmount = Math.round((percentageDiscountAmount / 100) * maxDiscountable)

                if (discountAmount > maxDiscountable) {
                    this.$notif({ type: 'normal', title: 'تخفیف نمی‌تواند بیشتر از مبلغ قابل تخفیف باشد' });
                } else {
                    this.orderFormComplete.discountAmount = discountAmount;
                    this.recalculateAmountPayableComplete()
                }
                this.percentageDiscountAmountComplete = null
                this.discountAmountComplete = null
            }
        },
        recalculateAmountPayableComplete() {
            let taxAmount = this.calculatingTaxAuto ? (this.orderDetailsComplete.orderAmount * 0.10) : 0
            let totalAmount = this.orderDetailsComplete.totalAmount + taxAmount
            let campaignDiscount = this.campaignDetailsComplete
                ? Math.round(totalAmount * (this.campaignDetailsComplete.discountPercent / 100))
                : 0
            let courierFee = this.orderFormComplete.courierFee || 0
            let walletAmount = this.orderFormComplete.useWallet ? this.orderFormComplete.walletAmount : 0

            this.orderDetailsComplete.amountPayable = Math.max(
                Math.round(totalAmount - campaignDiscount - this.orderFormComplete.discountAmount + courierFee - walletAmount),
                0
            )
        },
        applyCourierFeeComplete() {
            let courierFeeAmount = Number(this.courierFeeAmountComplete);
            courierFeeAmount = Math.round(courierFeeAmount);

            if (courierFeeAmount < 0) {
                this.$notif({ type: 'normal', title: 'هزینه ارسال نمی‌تواند منفی باشد' });
            } else {
                this.orderFormComplete.courierFee = courierFeeAmount || null
                this.recalculateAmountPayableComplete()
            }
            this.courierFeeAmountComplete = null
        },
        orderUseWalletOkComplete() {
            let taxAmount = this.calculatingTaxAuto ? (this.orderDetailsComplete.orderAmount * 0.10) : 0
            let totalAmount = this.orderDetailsComplete.totalAmount + taxAmount
            let campaignDiscount = this.campaignDetailsComplete
                ? Math.round(totalAmount * (this.campaignDetailsComplete.discountPercent / 100))
                : 0
            let courierFee = this.orderFormComplete.courierFee || 0
            let amountPayable = Math.max(
                Math.round(totalAmount - campaignDiscount - this.orderFormComplete.discountAmount + courierFee),
                0
            )
            let orderFormWalletAmount = Number(this.orderFormWalletAmountComplete);
            if (orderFormWalletAmount > amountPayable) {
                this.$notif({ type: 'normal', title: 'مبلغ اعتبار نمی‌تواند بیشتر از مبلغ قابل پرداخت باشد' });
            } else if (orderFormWalletAmount > this.customerComplete.loyaltyInfo.walletBalance) {
                this.$notif({ type: 'normal', title: 'مبلغ اعتبار نمی‌تواند بیشتر از موجودی کیف پول باشد' });
            } else if (orderFormWalletAmount < 0) {
                this.$notif({ type: 'normal', title: 'مبلغ اعتبار نمی‌تواند منفی باشد' });
            } else {
                this.orderFormComplete.useWallet = true
                this.orderFormComplete.walletAmount = orderFormWalletAmount
                this.recalculateAmountPayableComplete()
            }
            this.orderFormWalletAmountComplete = 0
        },
        showModalCustomersFindComplete() {
            if (this.accessHandling('employee', 'customer_create')) {
                this.$bvModal.show('customers-find-complete')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        handleSearchCustomerComplete(searchTerm) {
            this.loadingCustomerComplete = true
            clearTimeout(this.debounceTimeoutComplete)
            if (!searchTerm) {
                this.customerListComplete = []
                this.loadingCustomerComplete = false
                return
            }
            this.debounceTimeoutComplete = setTimeout(() => {
                this.getCustomersComplete(searchTerm)
            }, 1000)
        },
        getCustomersComplete(searchTerm) {
            this.parametersCustomerComplete.searchTerm = searchTerm
            storeService.getCustomers(this.storeId, this.parametersCustomerComplete).then(({ data }) => {
                this.customerListComplete = data.items
                this.loadingCustomerComplete = false
            })
        },
        getCustomerCampaignComplete(customerId, dataCustomer, method, dataMethod) {
            this.campaignDetailsComplete = null
            this.campaignsListComplete = []
            this.campaignsListMainComplete.forEach(item => {
                if (item.type == 2) {
                    this.campaignsListComplete.push(item)
                }
            });
            storeService.getCustomerCampaign(this.storeId, customerId).then(({ data }) => {
                let dataCampaignIds = data.campaignIds;
                dataCampaignIds.forEach(id => {
                    const found = this.campaignsListMainComplete.find(c => c.id === id);
                    if (found) {
                        const alreadyExists = this.campaignsListComplete.some(c => c.id === found.id);
                        if (!alreadyExists) {
                            this.campaignsListComplete.unshift(found);
                        }
                    }
                });
                if (this.campaignsListComplete.length) {
                    this.campaignDetailsComplete = this.campaignsListComplete[0]
                }
                this.customerComplete = dataCustomer
                this.customerPhoneNumberComplete = null
                this.loading.customersFindComplete = false
                this.$bvModal.hide('customers-find-complete')
                if (method == "ordersPreorderFindComplete") {
                    let ordersList = dataMethod.items
                    ordersList.forEach(product => {
                        this.orderDetailsComplete.numberProducts += product.count
                        this.orderDetailsComplete.orderAmount += (product.finalPrice * product.count)
                        this.orderDetailsComplete.totalAmount += (product.finalPrice * product.count)
                        this.orderDetailsComplete.amountPayable += (product.finalPrice * product.count)
                        let originalProduct = null;
                        for (let category of this.categories) {
                            originalProduct = category.products.find(p => p.id === product.productId);
                            if (originalProduct) break;
                            if (category.subCategories && category.subCategories.length) {
                                for (let subCategory of category.subCategories) {
                                    originalProduct = subCategory.products.find(p => p.id === product.productId);
                                    if (originalProduct) break;
                                }
                                if (originalProduct) break;
                            }
                        }
                        if (originalProduct) {
                            originalProduct.number = product.count;
                            this.ordersListComplete.push(originalProduct);
                        }
                    });
                    this.orderFormComplete.type = dataMethod.type
                    if (dataMethod.tableId) {
                        this.orderFormComplete.tableId = dataMethod.tableId
                    }
                    if (dataMethod.description) {
                        this.orderFormComplete.description = dataMethod.description
                    }
                    this.loadingButtonComplete = false;
                    if (dataMethod.customer) {
                        this.customerComplete = {
                            firstName: dataMethod.customer.firstName,
                            id: dataMethod.customer.id,
                            lastName: dataMethod.customer.lastName,
                            phoneNumber: dataMethod.customer.phoneNumber,
                            number: dataMethod.customer.number,
                        }
                        if (dataMethod.customer.loyaltyInfo) {
                            this.customerComplete.loyaltyInfo = {
                                loyaltyLevel: {
                                    number: dataMethod.customer.loyaltyInfo.loyaltyLevel ? dataMethod.customer.loyaltyInfo.loyaltyLevel.number : 0,
                                    name: dataMethod.customer.loyaltyInfo.loyaltyLevel ? dataMethod.customer.loyaltyInfo.loyaltyLevel.name : 0,
                                },
                                score: dataMethod.customer.loyaltyInfo.score,
                                walletBalance: dataMethod.customer.loyaltyInfo.walletBalance,
                            }
                        }
                    }
                    this.$bvModal.hide('show-order-list')
                    this.$bvModal.show('complete-order-modal')
                }
                else {
                    this.$notif({ type: 'success', title: 'مشتری با موفقیت به سفارش اضافه شد' });
                }
            })
                .catch(() => {
                    this.loading.customersFindComplete = false
                })
        },
        customersFindComplete() {
            this.$refs.customersFindCompleteValidation.validate().then((success) => {
                if (success) {
                    this.orderFormComplete.useWallet = false
                    this.orderFormComplete.walletAmount = 0
                    this.orderFormWalletAmountComplete = 0
                    if (this.searchCustomerComplete) {
                        this.loading.customersFindComplete = true;
                        this.customerComplete = {
                            firstName: this.searchCustomerComplete.firstName,
                            id: this.searchCustomerComplete.id,
                            lastName: this.searchCustomerComplete.lastName,
                            phoneNumber: this.searchCustomerComplete.phoneNumber,
                            number: this.searchCustomerComplete.number,
                        }
                        if (this.searchCustomerComplete.loyaltyLevel) {
                            this.customerComplete.loyaltyInfo = {
                                loyaltyLevel: {
                                    number: this.searchCustomerComplete.loyaltyLevel ? this.searchCustomerComplete.loyaltyLevel.number : 0,
                                    name: this.searchCustomerComplete.loyaltyLevel ? this.searchCustomerComplete.loyaltyLevel.name : 0,
                                },
                                score: this.searchCustomerComplete.score,
                                walletBalance: this.searchCustomerComplete.walletBalance,
                            }
                        }
                        if (this.isCustomerCampaignComplete) {
                            this.getCustomerCampaignComplete(this.customerComplete.id, this.customerComplete)
                        }
                        else {
                            this.$bvModal.hide('customers-find-complete')
                            this.$notif({ type: 'success', title: 'مشتری با موفقیت به سفارش اضافه شد' });
                            this.loading.customersFindComplete = false;
                        }
                        this.searchCustomerComplete = null
                        this.customerPhoneNumberComplete = null
                        this.$refs.customersFindCompleteValidation.reset();
                    }
                    else {
                        this.customerFormComplete.gender = null
                        this.customerFormComplete.birthDate = null
                        this.customerFormComplete.lastName = null
                        this.customerFormComplete.firstName = null
                        this.customerFormComplete.phoneNumber = null
                        this.loading.customersFindComplete = true;
                        storeService.customersFind(this.storeId, this.customerPhoneNumberComplete).then(({ data }) => {
                            if (data.isExists) {
                                if (this.isCustomerCampaignComplete) {
                                    this.getCustomerCampaignComplete(data.customer.id, data.customer)
                                }
                                else {
                                    this.customerComplete = data.customer
                                    this.customerPhoneNumberComplete = null
                                    this.loading.customersFindComplete = false
                                    this.$bvModal.hide('customers-find-complete')
                                    this.$notif({ type: 'success', title: 'مشتری با موفقیت به سفارش اضافه شد' });
                                }
                            }
                            else {
                                this.customerFormComplete.phoneNumber = this.customerPhoneNumberComplete
                                this.$bvModal.hide('customers-find-complete')
                                this.$bvModal.show('create-customer-complete')
                                this.customerPhoneNumberComplete = null
                                this.$notif({ type: 'normal', title: 'مشتری با این شماره یافت نشد' });
                                this.loading.customersFindComplete = false
                            }
                            this.$refs.customersFindCompleteValidation.reset();
                        })
                            .catch(() => {
                                this.$refs.customersFindCompleteValidation.reset();
                                this.loading.customersFindComplete = false
                            });
                    }
                }
            });
        },
        createCustomerComplete() {
            this.$refs.createCustomerCompleteValidation.validate().then((success) => {
                if (success) {
                    this.loading.createCustomerComplete = true;
                    storeService.createCustomer(this.storeId, this.customerFormComplete).then(({ data }) => {
                        this.customerComplete = data
                        this.customerFormComplete.gender = null
                        this.customerFormComplete.birthDate = null
                        this.customerFormComplete.lastName = null
                        this.customerFormComplete.firstName = null
                        this.customerFormComplete.phoneNumber = null
                        this.loading.createCustomerComplete = false;
                        this.$refs.createCustomerCompleteValidation.reset();
                        this.$bvModal.hide('create-customer-complete')
                        this.$notif({ type: 'success', title: 'مشتری با موفقیت به سفارش اضافه شد' });
                    })
                        .catch(() => {
                            this.$bvModal.hide('create-customer-complete')
                            this.customerFormComplete.gender = null
                            this.customerFormComplete.birthDate = null
                            this.customerFormComplete.lastName = null
                            this.customerFormComplete.firstName = null
                            this.customerFormComplete.phoneNumber = null
                            this.loading.createCustomerComplete = false;
                        });
                }
            });
        },
        ordersPreorderFindComplete(dailyNumber) {
            this.loadingButtonComplete = true;
            this.deleteInvoiceComplete()
            this.orderFormComplete.orderId = this.orderId
            storeService.ordersPreorderFind(this.storeId, dailyNumber).then(({ data }) => {
                if (this.isCustomerCampaignComplete && data.customer) {
                    this.getCustomerCampaignComplete(data.customer.id, data.customer, "ordersPreorderFindComplete", data)
                }
                else {
                    let ordersList = data.items
                    ordersList.forEach(product => {
                        this.orderDetailsComplete.numberProducts += product.count
                        this.orderDetailsComplete.orderAmount += (product.finalPrice * product.count)
                        this.orderDetailsComplete.totalAmount += (product.finalPrice * product.count)
                        this.orderDetailsComplete.amountPayable += (product.finalPrice * product.count)
                        let originalProduct = null;
                        for (let category of this.categories) {
                            originalProduct = category.products.find(p => p.id === product.productId);
                            if (originalProduct) break;
                            if (category.subCategories && category.subCategories.length) {
                                for (let subCategory of category.subCategories) {
                                    originalProduct = subCategory.products.find(p => p.id === product.productId);
                                    if (originalProduct) break;
                                }
                                if (originalProduct) break;
                            }
                        }
                        if (originalProduct) {
                            originalProduct.number = product.count;
                            this.ordersListComplete.push(originalProduct);
                        }
                    });
                    this.orderFormComplete.type = data.type
                    if (data.tableId) {
                        this.orderFormComplete.tableId = data.tableId
                    }
                    if (data.description) {
                        this.orderFormComplete.description = data.description
                    }
                    this.loadingButtonComplete = false;
                    if (data.customer) {
                        this.customerComplete = {
                            firstName: data.customer.firstName,
                            id: data.customer.id,
                            lastName: data.customer.lastName,
                            phoneNumber: data.customer.phoneNumber,
                            number: data.customer.number,
                        }
                        if (data.customer.loyaltyInfo) {
                            this.customerComplete.loyaltyInfo = {
                                loyaltyLevel: {
                                    number: data.customer.loyaltyInfo.loyaltyLevel ? data.customer.loyaltyInfo.loyaltyLevel.number : 0,
                                    name: data.customer.loyaltyInfo.loyaltyLevel ? data.customer.loyaltyInfo.loyaltyLevel.name : 0,
                                },
                                score: data.customer.loyaltyInfo.score,
                                walletBalance: data.customer.loyaltyInfo.walletBalance,
                            }
                        }
                    }
                    this.$bvModal.hide('show-order-list')
                    this.$bvModal.show('complete-order-modal')
                    this.loading.customersFindComplete = false;
                }
            })
                .catch(() => {
                    this.loadingButtonComplete = false;
                });
        },
        ordersCreateCompleteHandle() {
            if (this.ordersListComplete.length) {
                this.orderFormComplete.payments = []
                if (this.paymentMethodComplete == 4) {
                    this.$bvModal.show('enter-amount-complete')
                }
                else {
                    this.orderFormComplete.payments = [{
                        method: this.paymentMethodComplete,
                        amount: Math.max(
                            Math.round(
                                (this.calculatingTaxAuto ? this.orderDetailsComplete.totalAmount + (this.orderDetailsComplete.orderAmount * 0.10) : this.orderDetailsComplete.totalAmount)
                                - (this.campaignDetailsComplete ? ((this.calculatingTaxAuto ? (this.orderDetailsComplete.totalAmount + (this.orderDetailsComplete.orderAmount * 0.10)) : this.orderDetailsComplete.totalAmount) * (this.campaignDetailsComplete.discountPercent / 100)) : 0)
                                - this.orderFormComplete.discountAmount
                                + (this.orderFormComplete.courierFee || 0)
                                - (this.orderFormComplete.useWallet ? this.orderFormComplete.walletAmount : 0)
                            ),
                            0
                        )
                    }]
                    this.ordersCreateComplete()
                }
            }
            else {
                this.$notif({ type: 'normal', title: 'برای تکمیل سفارش حداقل یک مورد اضافه کنید' });
            }
        },
        combinedPaymentCompleteHandle() {
            this.orderFormComplete.payments = []

            let taxAmount = this.calculatingTaxAuto ? (this.orderDetailsComplete.orderAmount * 0.10) : 0
            let totalAmount = this.orderDetailsComplete.totalAmount + taxAmount
            let campaignDiscount = this.campaignDetailsComplete
                ? Math.round(totalAmount * (this.campaignDetailsComplete.discountPercent / 100))
                : 0
            let courierFee = this.orderFormComplete.courierFee || 0
            let walletAmount = this.orderFormComplete.useWallet ? this.orderFormComplete.walletAmount : 0
            let amountPayable = Math.max(
                Math.round(totalAmount - campaignDiscount - this.orderFormComplete.discountAmount + courierFee - walletAmount),
                0
            )
            let totalAmountPaid = 0
            let tempAmount = 0
            this.combinedPaymentComplete.forEach(item => {
                if (item.amount) {
                    tempAmount = Number(item.amount);
                    tempAmount = Math.round(tempAmount);
                    totalAmountPaid += tempAmount;
                    this.orderFormComplete.payments.push({
                        method: item.method,
                        amount: tempAmount
                    })
                }
            });
            if (totalAmountPaid == amountPayable) {
                this.ordersCreateComplete()
            }
            else {
                this.$notif({ type: 'normal', title: 'مبالغ وارد شده با مبلغ قابل پرداخت مغایرت دارد' });
            }
        },
        ordersCreateComplete() {
            this.loading.ordersCreateComplete = true;
            this.orderFormComplete.items = []
            this.ordersListComplete.forEach(product => {
                this.orderFormComplete.items.push({
                    productId: product.id,
                    count: product.number
                });
            });
            if (this.campaignDetailsComplete) {
                this.orderFormComplete.campaignId = this.campaignDetailsComplete.id
            }
            this.orderFormComplete.customerNumber = this.customerComplete.number
            if (this.orderFormComplete.walletAmount == 0) {
                this.orderFormComplete.walletAmount = null
            }
            if (this.orderFormComplete.courierFee === 0 || !this.orderFormComplete.courierFee) {
                this.orderFormComplete.courierFee = null
            } else {
                this.orderFormComplete.courierFee = Number(this.orderFormComplete.courierFee)
            }
            storeService.ordersCreate(this.storeId, this.orderFormComplete).then(({ data }) => {
                this.dataResponseComplete = data
                this.loading.ordersCreateComplete = false;
                this.$bvModal.hide('enter-amount-complete')
                this.$notif({ type: 'success', title: 'سفارش با موفقیت ثبت شد' });
                if (this.automaticPrinting) {
                    if (this.certificateId || this.certificateId == 0) {
                        this.registerOrderComplete(this.orderFormComplete);
                    }
                    else {
                        this.deleteInvoiceComplete()
                        this.$bvModal.hide('complete-order-modal')
                        this.ordersToday(false, true);
                    }
                }
                else {
                    this.deleteInvoiceComplete()
                    this.$bvModal.hide('complete-order-modal')
                    this.ordersToday(false, true);
                }
            })
                .catch(() => {
                    this.loading.ordersCreateComplete = false;
                });
        },
        registerOrderComplete(order) {
            let newOrder = order
            newOrder.id = this.orderNumberComplete
            this.printQueueComplete.push(newOrder);
            this.orderNumberComplete++;
            if (!this.isPrintingComplete) {
                this.startPrintingComplete();
            }
        },
        startPrintingComplete() {
            this.isPrintingComplete = true;
            const printNext = () => {
                if (this.printQueueComplete.length === 0) {
                    this.isPrintingComplete = false;
                    return;
                }
                this.orderPrintComplete.items = this.ordersListComplete
                this.orderPrintComplete.createdAt = this.dataResponseComplete.createdAt
                this.orderPrintComplete.dailyOrderNumber = this.dataResponseComplete.dailyOrderNumber
                this.orderPrintComplete.storeOrderNumber = this.dataResponseComplete.storeOrderNumber
                this.orderPrintComplete.urlName = this.urlName
                this.orderPrintComplete.orderAmount = this.dataResponseComplete.totalAmount
                this.orderPrintComplete.amountPayable = this.dataResponseComplete.payableAmount
                this.orderPrintComplete.taxAmount = this.dataResponseComplete.taxAmount
                this.orderPrintComplete.discountAmount = this.dataResponseComplete.discountAmount
                this.orderPrintComplete.usedWalletAmount = this.dataResponseComplete.usedWalletAmount
                this.orderPrintComplete.campaignDiscountAmount = this.dataResponseComplete.campaignDiscountAmount
                this.orderPrintComplete.productDiscountAmount = this.dataResponseComplete.productDiscountAmount
                this.orderPrintComplete.courierFee = this.orderFormComplete.courierFee
                this.orderPrintComplete.firstName = this.customerComplete.firstName
                this.orderPrintComplete.lastName = this.customerComplete.lastName
                if (this.orderFormComplete.type == 1) {
                    this.orderPrintComplete.phoneNumber = this.customerComplete.phoneNumber
                    this.orderPrintComplete.address = this.customerComplete.address
                }
                setTimeout(() => {
                    this.$refs.PrinterComplete.printCustomerInvoice();
                }, 100);
                setTimeout(() => {
                    this.deleteInvoiceComplete()
                    this.$bvModal.hide('complete-order-modal')
                    this.ordersToday(false, true);
                }, 1000);
                this.removeFromQueueByIdComplete(this.printQueueComplete[0].id);
                setTimeout(printNext, 1000);
            };
            printNext();
        },
        removeFromQueueByIdComplete(orderId) {
            this.printQueueComplete = this.printQueueComplete.filter(order => order.id !== orderId);
        },
        tablesActive(type) {
            storeService.tablesActive(this.storeId).then(({ data }) => {
                this.tables = data.tables
                if (type == 'show-table') {
                    this.loadingShowTable = false
                    this.$bvModal.show('show-table')
                }
                else {
                    this.getAllProducts();
                }
            })
        },
    },
    async mounted() {
        let viewModeList = localStorage.getItem("viewModeList")
        if (viewModeList != null) {
            viewModeList == 'true' ? this.viewModeList = true : this.viewModeList = false
        }
        this.storeId = localStorage.getItem("storeId");
        this.certificateId = localStorage.getItem("certificateId");
        let automaticPrinting = localStorage.getItem("automaticPrinting")
        if (this.certificateId || this.certificateId == 0) {
            this.automaticPrinting = true
        }
        else {
            this.automaticPrinting = false
        }
        if (automaticPrinting != null) {
            automaticPrinting == 'true' ? this.automaticPrinting = true : this.automaticPrinting = false
        }
        const soundPath = require('@/assets/sound/notification2.wav')
        this.notification = new Audio(soundPath);
        if (this.automaticUpdates) {
            this.connection = await this.startConnection();
        }
        window.addEventListener('keydown', this.keyboardHandling);
        const today = new Date();
        this.currentDate = this.formatDate2(today);
        this.getCompletionStatus();

    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.keyboardHandling);
        this.selfStop = true;
        if (this.reconnectIntervalId) {
            clearInterval(this.reconnectIntervalId);
        }
        if (this.connection) {
            this.connection.stop();
        }
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.display-none-daily-orders {
    @media (max-width: 460px) {
        display: none !important;
    }
}

.line-between-two-elements-invoice-pre-invoice {
    flex-grow: 1;
    border-bottom: 1px dashed #9393935d;
}

.orders-container-pre-invoice {
    height: 354.5px;
    overflow-y: scroll;
}

.orders-container-pre-invoice::-webkit-scrollbar {
    width: 4px;
    border-radius: 6px;
}

.orders-container-pre-invoice::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
}

.orders-container-pre-invoice::-webkit-scrollbar-thumb {
    background-color: #b9b9b99a;
    border-radius: 6px;
}

.orders-container-pre-invoice::-webkit-scrollbar-thumb:hover {
    background-color: #9c9c9ca6;
}

.pre-invoice-registration-cover {
    background-color: rgb(0 0 0 / 80%);
    bottom: 0;
    z-index: 1;
    right: 0;
    left: 0;
    top: 0;
}

.pre-invoice-registration-cover-product {
    bottom: 0;
    z-index: 1;
    right: 0;
    left: 0;
    top: 0;
}

.border-bottom-pre-invoice {
    border-bottom: 1px #93939336 solid;
}

.bg-info-pre-invoice {
    background-color: #576fbd;
    transition: background-color 0.1s ease-in-out;
}

.text-ellipsis-single-pre-invoice {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.overflow-y-scroll-pre-invoice {
    @media (min-width: 767px) {
        height: 680px;
        overflow-y: scroll;
    }
}

.overflow-y-scroll-pre-invoice::-webkit-scrollbar {
    width: 4px;
    border-radius: 6px;
}

.overflow-y-scroll-pre-invoice::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
}

.overflow-y-scroll-pre-invoice::-webkit-scrollbar-thumb {
    background-color: #b9b9b99a;
    border-radius: 6px;
}

.overflow-y-scroll-pre-invoice::-webkit-scrollbar-thumb:hover {
    background-color: #9c9c9ca6;
}

.pre-invoice-registration-bg-main {
    @media (max-width: 767px) {
        width: 100px;
        height: 100px;
    }

    @media (min-width: 767px) {
        width: 150px;
        height: 110px;
    }
}

.pre-invoice-registration-bg {
    @media (max-width: 767px) {
        width: 100px;
        height: 100px;
    }

    @media (min-width: 767px) {
        width: 150px;
        height: 110px;
    }

    background-color: #000000;
}

.toggle-content-invoice {
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.display-none-sm-invoice-2 {
    @media (max-width: 990px) {
        display: none;
    }

    @media (min-width: 990px) {
        display: flex;
        align-items: center;
    }
}
</style>